// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-50: #fdecec;
  --primary-100: #f8d0d1;
  --primary-200: #f0a8aa;
  --primary-300: #e57a7d;
  --primary-400: #d64d52;
  --primary-500: #c6272a;
  --primary-600: #c6272a;
  --primary-700: #a81f22;
  --primary-800: #8a191c;
  --primary-900: #6b1215;
  --primary-light: rgba(198, 39, 42, 0.15);
  --primary-light-white: rgba(198, 39, 42, 0.25);
  --brand: #c6272a;
  --bs-primary: #c6272a;
  --bs-primary-rgb: 198, 39, 42;
  --bs-link-color: #c6272a;
  --bs-link-hover-color: #a81f22;
}

[data-theme="dark"] {
  --primary-50: rgba(198, 39, 42, 0.12);
}

html,
body {
  font-family: Poppins, sans-serif;
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #c6272a;
  --bs-btn-border-color: #c6272a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #a81f22;
  --bs-btn-hover-border-color: #a81f22;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #8a191c;
  --bs-btn-active-border-color: #8a191c;
  --bs-btn-disabled-bg: #c6272a;
  --bs-btn-disabled-border-color: #c6272a;
}

.btn-outline-primary {
  --bs-btn-color: #c6272a;
  --bs-btn-border-color: #c6272a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #c6272a;
  --bs-btn-hover-border-color: #c6272a;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #a81f22;
  --bs-btn-active-border-color: #a81f22;
}

.text-primary,
a.text-primary {
  color: #c6272a !important;
}

.bg-primary {
  background-color: #c6272a !important;
}

.border-primary {
  border-color: #c6272a !important;
}

.bg-primary-subtle {
  background-color: #fdecec !important;
}

.sidebar-logo img.light-logo,
.sidebar-logo img.dark-logo {
  max-width: 168px;
  max-height: 48px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.sidebar-logo img.logo-icon {
  width: 42px;
  height: 42px;
  object-fit: contain;
}

.auth-brand-logo {
  max-width: 210px;
  height: auto;
  object-fit: contain;
}

.agent-onboarding-logo {
  display: block;
  max-width: 132px;
  max-height: 44px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.agent-onboarding-page .form-check.style-check {
  gap: 0.75rem;
}

.agent-onboarding-page .form-check.style-check .form-check-input {
  width: 1.15rem;
  height: 1.15rem;
  margin-top: 0.2rem;
  flex-shrink: 0;
}

.agent-onboarding-page .form-check.style-check .form-check-label {
  padding-top: 0.05rem;
  line-height: 1.5;
}

.catalog-card {
  overflow: hidden;
  border-radius: 16px;
}

.catalog-image-wrap {
  width: 100%;
  overflow: hidden;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-size: 0.875rem;
}

.catalog-image-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.catalog-card .card-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.5em;
  line-height: 1.25;
}

.catalog-card .card-body {
  padding: 1.1rem 1.15rem 1.2rem;
}

.package-catalog-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  align-items: stretch;
}

.package-card {
  min-width: 0;
}

.package-card__image,
.package-card .catalog-image-wrap.package-card__image,
.package-card__image-skeleton {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 10;
  flex-shrink: 0;
}

.package-card__image-skeleton {
  display: block;
  border-radius: 0 !important;
}

.package-card .card-body {
  padding: 0.9rem 0.95rem 1rem;
  gap: 0.7rem;
}

.package-card__code {
  letter-spacing: 0.04em;
  line-height: 1.3;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.package-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.package-card .card-title,
.package-card__name {
  width: 100%;
  min-height: 1.5em;
  max-height: 1.5em;
  font-size: 0.98rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.25;
}

.package-card .agent-status-badge {
  padding: 0.15rem 0.7rem;
  font-size: 0.7rem;
}

.package-card__meta {
  display: grid;
  gap: 0.28rem;
}

.package-card__row {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  font-size: 0.8rem;
  line-height: 1.35;
}

.package-card__label {
  color: #6b7280;
  font-weight: 500;
  font-size: 0.72rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.package-card__value {
  color: #111827;
  font-weight: 600;
  text-align: right;
  min-width: 0;
  overflow-wrap: anywhere;
}

.package-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-top: 0.55rem;
  border-top: 1px solid #eef0f3;
}

.package-card__prices {
  min-width: 0;
}

.package-card__book {
  flex: 0 0 auto;
  min-width: 4.75rem;
}

.package-card__net {
  color: var(--primary-600);
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.3;
}

.package-catalog-head {
  background: #fff;
  border-radius: 12px;
  padding: 1.15rem 1.25rem 1.2rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);
  min-width: 0;
  max-width: 100%;
}

.package-catalog-header {
  margin-bottom: 1rem !important;
}

.page-head-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}

.page-head-actions .page-toolbar {
  width: 100%;
}

.package-catalog-head .page-head-actions {
  margin-bottom: 0;
}

.package-catalog-head .page-head-actions .page-toolbar {
  width: auto;
}

.package-filter-bar {
  display: grid;
  grid-template-columns: minmax(12rem, 1.35fr) minmax(8.5rem, 1fr) minmax(8rem, 0.9fr) minmax(10.5rem, 1.1fr) minmax(8.5rem, 1fr);
  gap: 0.75rem 0.85rem;
  align-items: end;
  min-width: 0;
}

.package-filter-bar--hotels {
  grid-template-columns: minmax(12rem, 1.4fr) minmax(9rem, 1fr) minmax(9rem, 1fr) minmax(11rem, 1.15fr);
}

.package-filter-bar--flights {
  grid-template-columns: minmax(16rem, 28rem);
}

.package-filter-bar__field {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.package-filter-bar__label {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.02em;
}

.package-filter-bar .form-control,
.package-filter-bar .agent-select {
  width: 100%;
  min-width: 0;
}

.package-filter-range {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
}

.package-filter-range .form-control {
  min-width: 0;
  flex: 1 1;
}

.package-filter-range-sep {
  color: #9ca3af;
  font-weight: 600;
  flex: 0 0 auto;
}

@media (min-width: 768px) {
  .package-catalog-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1200px) {
  .package-catalog-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (min-width: 1650px) {
  .package-catalog-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

@media (max-width: 1199.98px) {
  .package-filter-bar,
  .package-filter-bar--hotels {
    grid-template-columns: minmax(11rem, 1fr) minmax(8rem, 1fr) minmax(8rem, 1fr);
  }
}

@media (max-width: 991.98px) {
  .package-filter-bar,
  .package-filter-bar--hotels {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767.98px) {
  .package-catalog-head {
    padding: 1rem 1rem 1.1rem;
  }

  .package-filter-bar,
  .package-filter-bar--hotels,
  .package-filter-bar--flights {
    grid-template-columns: 1fr;
  }
}

.agent-skeleton {
  display: block;
  background-color: #e8eaed;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

.agent-skeleton::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.55) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: agent-skeleton-shimmer 1.5s ease-in-out infinite;
}

@keyframes agent-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .agent-skeleton::after {
    animation: none;
  }
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body,
#root {
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
}

body {
  overflow-x: hidden;
}

.dashboard-main,
.dashboard-main-body,
.booking-page,
.booking-page .container-fluid,
.booking-page .row,
.booking-page .col-lg-8,
.booking-page .col-lg-4,
.booking-page .card,
.booking-page .card-body {
  min-width: 0;
}

.navbar-search {
  position: relative;
  display: none;
  flex: 0 1 auto;
  min-width: 0;
}

@media (min-width: 992px) {
  .navbar-search {
    display: block;
  }
}

.navbar-search-field {
  position: relative;
  display: block;
  width: min(24.25rem, 100%);
}

.navbar-search input {
  display: block;
  width: 100%;
  height: 2.5rem;
  background-color: var(--neutral-50);
  border: 1px solid var(--input-form-light);
  border-radius: 0.5rem;
  padding-block: 0.3125rem;
  padding-inline-start: 2.5rem;
  padding-inline-end: 1rem;
  color: var(--text-primary-light);
}

.navbar-search input:focus {
  border-color: var(--primary-600);
  outline: none;
}

.navbar-search input[type="search"]::-webkit-search-decoration,
.navbar-search input[type="search"]::-webkit-search-cancel-button,
.navbar-search input[type="search"]::-webkit-search-results-button,
.navbar-search input[type="search"]::-webkit-search-results-decoration {
  appearance: none;
}

.navbar-search-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  width: 2.5rem;
  height: 2.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-secondary-light, #6b7280);
  font-size: 1.125rem;
  line-height: 1;
  pointer-events: none;
  z-index: 1;
}

.navbar-search-icon iconify-icon {
  display: block;
  width: 1.125rem;
  height: 1.125rem;
  color: inherit;
}

.navbar-search-results {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  width: min(28rem, calc(100vw - 1.5rem));
  max-height: min(28rem, calc(100vh - 6rem));
  overflow-y: auto;
  background: var(--white);
  border: 1px solid var(--input-form-light);
  border-radius: 0.75rem;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.14);
  z-index: 1080;
  padding: 0.5rem 0;
}

.navbar-search-status {
  padding: 0.875rem 1rem;
  color: var(--text-secondary-light);
  font-size: 0.8125rem;
}

.navbar-search-group + .navbar-search-group {
  border-top: 1px solid var(--input-form-light);
  margin-top: 0.25rem;
  padding-top: 0.25rem;
}

.navbar-search-group-title {
  padding: 0.5rem 1rem 0.25rem;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary-light);
}

.navbar-search-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.625rem 1rem;
  color: var(--text-primary-light);
  text-decoration: none;
}

.navbar-search-item:hover,
.navbar-search-item.is-active {
  background: var(--primary-50);
  color: var(--primary-600);
}

.navbar-search-item-icon {
  width: 1.75rem;
  height: 1.75rem;
  flex: 0 0 1.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--neutral-200);
  color: var(--primary-600);
  font-size: 0.95rem;
}

.navbar-search-item-copy {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.navbar-search-item-title {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.3;
  word-break: break-word;
}

.navbar-search-item-subtitle {
  font-size: 0.75rem;
  color: var(--text-secondary-light);
  line-height: 1.35;
  word-break: break-word;
}

.navbar-search-more {
  display: block;
  padding: 0.375rem 1rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--primary-600);
  text-decoration: none;
}

.navbar-search-more:hover {
  text-decoration: underline;
}

.navbar-header .col-auto > .d-flex {
  flex-wrap: nowrap;
}

.sidebar-toggle,
.sidebar-mobile-toggle {
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sidebar-toggle {
  display: none;
}

@media (min-width: 1200px) {
  .sidebar-toggle {
    display: inline-flex;
  }
}

.sidebar-mobile-toggle {
  display: inline-flex;
}

@media (min-width: 1200px) {
  .sidebar-mobile-toggle {
    display: none;
  }
}

.sidebar-menu .menu-item,
.sidebar-logout {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 2.5rem;
  width: 100%;
  overflow: visible;
}

.sidebar-menu .menu-item .menu-icon,
.sidebar-logout .menu-icon {
  width: 18px;
  min-width: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-inline-end: 0;
  line-height: 1;
}

.sidebar-menu .menu-item .menu-icon iconify-icon,
.sidebar-logout .menu-icon iconify-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
}

.sidebar-menu .menu-item .menu-label,
.sidebar-logout .menu-label {
  min-width: 0;
  flex: 1 1 auto;
}

.sidebar-menu .menu-item .menu-label,
.sidebar-menu .menu-item .menu-icon,
.sidebar-logout .menu-label,
.sidebar-logout .menu-icon {
  pointer-events: none;
}

.sidebar-menu .menu-item .sidebar-tooltip {
  display: none;
}

.app-shell.sidebar-collapsed .sidebar .menu-item {
  justify-content: center;
  gap: 0;
  padding-inline: 0;
}

.app-shell.sidebar-collapsed .sidebar .menu-item .menu-icon {
  display: inline-flex !important;
  margin-inline-end: 0 !important;
}

.app-shell.sidebar-collapsed .sidebar .menu-item .menu-label {
  display: none !important;
}

.app-shell.sidebar-collapsed .sidebar .menu-item .sidebar-tooltip {
  position: absolute;
  inset-inline-start: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  padding: 0.375rem 0.625rem;
  border-radius: 0.5rem;
  background: var(--neutral-900);
  color: #fff;
  font-size: 0.8125rem;
  line-height: 1;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.22);
}

.app-shell.sidebar-collapsed .sidebar .menu-item:hover .sidebar-tooltip,
.app-shell.sidebar-collapsed .sidebar .menu-item:focus-visible .sidebar-tooltip,
.app-shell.sidebar-collapsed .sidebar .menu-item:focus-within .sidebar-tooltip {
  opacity: 1;
  visibility: visible;
}

.app-shell.sidebar-collapsed .sidebar .menu-item .sidebar-tooltip::before {
  content: "";
  position: absolute;
  inset-inline-start: -4px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  width: 8px;
  height: 8px;
  background: var(--neutral-900);
}

.sidebar {
  display: flex;
  flex-direction: column;
}

.sidebar-menu-area {
  flex: 1 1 auto;
  min-height: 0;
  height: auto !important;
}

.sidebar-footer {
  flex: 0 0 auto;
  padding: 0.75rem 1rem 1rem;
  border-inline-end: 1px solid var(--neutral-200);
  border-block-start: 1px solid var(--neutral-200);
}

.sidebar-logout {
  border: 0;
  background: transparent;
  padding: 0.625rem 0.75rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: var(--text-secondary-light);
  border-radius: 8px;
  cursor: pointer;
  text-align: start;
}

.sidebar-logout:hover,
.sidebar-logout:focus-visible {
  color: var(--primary-600);
}

.app-shell.sidebar-collapsed .sidebar .sidebar-menu-group-title {
  display: none !important;
}

.app-shell.sidebar-collapsed .sidebar .sidebar-submenu {
  display: none !important;
}

.app-shell.sidebar-collapsed .sidebar .dropdown > a::after {
  display: none !important;
}

.app-shell.sidebar-collapsed .dashboard-main {
  margin-inline-start: 5.375rem !important;
}

@media (min-width: 1400px) {
  .app-shell.sidebar-collapsed .dashboard-main {
    margin-inline-start: 5.375rem !important;
  }
}

@media (min-width: 1650px) {
  .app-shell.sidebar-collapsed .dashboard-main {
    margin-inline-start: 5.375rem !important;
  }
}

.sidebar-menu li a iconify-icon.menu-icon,
.sidebar-menu li.dropdown > a iconify-icon.menu-icon,
.sidebar-menu .sidebar-submenu li a iconify-icon.menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  min-width: 24px;
  margin-inline-end: 0.5rem;
  font-size: 1.125rem;
  line-height: 1.2;
}

@media (min-width: 1650px) {
  .sidebar-menu li a iconify-icon.menu-icon,
  .sidebar-menu li.dropdown > a iconify-icon.menu-icon,
  .sidebar-menu .sidebar-submenu li a iconify-icon.menu-icon {
    font-size: 1.375rem;
    margin-inline-end: 0.75rem;
  }
}

.sidebar-menu li.dropdown > a {
  position: relative;
  margin: 6px 0px;
}

.sidebar-menu li.dropdown.open > a,
.sidebar-menu li.dropdown.dropdown-open > a {
  background-color: var(--primary-50);
  color: var(--primary-600);
}

.sidebar-menu li.dropdown.open > a:hover,
.sidebar-menu li.dropdown.dropdown-open > a:hover {
  background-color: var(--primary-100);
  color: var(--primary-700);
}

.sidebar-menu .sidebar-submenu li.active-page a,
.sidebar-menu .sidebar-submenu li a.active-page {
  background-color: var(--primary-600);
  color: #fff;
}

.sidebar-menu .sidebar-submenu li.active-page a:hover,
.sidebar-menu .sidebar-submenu li a.active-page:hover {
  color: #fff;
}

.sidebar-menu .sidebar-submenu {
  padding-inline-start: 1.75rem;
}

@media (min-width: 1650px) {
  .sidebar-menu .sidebar-submenu {
    padding-inline-start: 3rem;
  }
}

.sidebar-menu .sidebar-submenu li a {
  padding: 0.4375rem 0.75rem;
}

.sidebar-menu .sidebar-submenu .menu-item {
  padding-inline-start: 0.25rem;
}

.sidebar-menu li.dropdown > a::after {
  inset-inline-end: 0.75rem;
}

.sidebar-menu li a,
.sidebar-menu li a:link,
.sidebar-menu li a:visited,
.sidebar-menu li.dropdown > a,
.sidebar-menu .sidebar-submenu li a {
  align-items: center;
  min-height: 2.5rem;
  color: var(--text-secondary-light);
}

.sidebar-menu li > a.active-page,
.sidebar-menu li > a.active-page:visited,
.sidebar-menu li > a.active-page:hover,
.sidebar-menu .sidebar-submenu li.active-page a,
.sidebar-menu .sidebar-submenu li.active-page a:visited {
  color: #fff;
}

.sidebar-menu li a .menu-icon,
.sidebar-menu li.dropdown > a .menu-icon,
.sidebar-menu .sidebar-submenu li a .menu-icon,
.sidebar-logout .menu-icon {
  flex: 0 0 24px;
  min-width: 24px;
}

.app-shell,
.dashboard-main,
.navbar-header,
.navbar-header .row,
.navbar-header .col-auto {
  min-width: 0;
}

.navbar-header {
  height: auto;
  min-height: 4.5rem;
  overflow: visible;
  z-index: 1030;
}

.navbar-header-row {
  flex-wrap: nowrap;
  margin-left: 0;
  margin-right: 0;
}

.navbar-header-start,
.navbar-header-actions {
  min-width: 0;
  overflow: visible;
}

.navbar-action-btn {
  flex-shrink: 0;
}

.navbar-shortcuts {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  width: 100%;
  min-width: 0;
}

.navbar-shortcut {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 2.5rem;
  padding: 0.4rem 0.8rem;
  border-radius: 8px;
  color: var(--text-secondary-light);
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
}

.navbar-shortcut:hover,
.navbar-shortcut:focus-visible,
.navbar-shortcut.is-active {
  color: var(--primary-600);
  background: var(--primary-50);
}

.navbar-shortcut-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
}

.navbar-shortcut-icon iconify-icon {
  font-size: 1.05rem;
}

.navbar-wallet {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-height: 40px;
  padding: 0.3rem 0.8rem 0.3rem 0.4rem;
  border-radius: 999px;
  background: var(--neutral-200);
  color: var(--text-primary-light);
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
}

.navbar-wallet:hover,
.navbar-wallet:focus-visible {
  color: var(--primary-600);
  background: var(--primary-50);
}

.navbar-wallet-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff;
  color: var(--primary-600);
}

.navbar-wallet-icon iconify-icon {
  font-size: 1rem;
}

.navbar-wallet-amount {
  color: var(--primary-600);
}

.navbar-unread-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  transform: none;
  min-width: 1.125rem;
  height: 1.125rem;
  padding: 0 0.25rem;
  font-size: 0.625rem;
  line-height: 1.125rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.profile-dropdown {
  position: relative;
  flex-shrink: 0;
}

.profile-dropdown-toggle.has-indicator::before {
  display: none;
}

.dropdown-menu.profile-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  left: auto;
  inset-inline-end: 0;
  inset-inline-start: auto;
  display: none;
  width: min(20rem, calc(100vw - 1.5rem));
  min-width: 0;
  max-width: min(20rem, calc(100vw - 1.5rem));
  padding: 0.75rem;
  overflow: hidden;
  box-sizing: border-box;
  transform: none !important;
  z-index: 1080;
}

.dropdown-menu.profile-dropdown-menu.show {
  display: block;
}

.profile-dropdown-head {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.75rem 0.75rem 0.75rem 0.875rem;
  margin-bottom: 0.75rem;
  border-radius: 0.5rem;
  background: var(--primary-50);
  overflow: hidden;
}

.profile-dropdown-identity {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  flex: 1 1 auto;
  padding-inline-end: 0.25rem;
}

.profile-dropdown-avatar {
  flex-shrink: 0;
}

.profile-dropdown-meta {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.profile-dropdown-meta h6,
.profile-dropdown-meta span {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-dropdown-close,
.profile-dropdown-close.agent-icon-btn {
  position: static !important;
  top: auto !important;
  right: auto !important;
  inset: auto !important;
  flex: 0 0 1.75rem;
  width: 1.75rem;
  height: 1.75rem;
  margin: 0;
  align-self: flex-start;
  background: #fff;
  color: var(--primary-600);
  box-shadow: none;
}

.profile-dropdown-close iconify-icon {
  font-size: 0.875rem;
  line-height: 1;
}

.profile-dropdown-list {
  padding: 0 0.25rem 0.25rem;
  margin: 0;
}

.profile-dropdown-list .dropdown-item {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-dropdown-list .dropdown-item iconify-icon {
  flex-shrink: 0;
}

.booking-page .container-fluid {
  width: 100%;
}

.booking-page .row {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

.booking-page .col-lg-8 {
  flex: 0 0 72%;
  max-width: 72%;
}

.booking-page .col-lg-4 {
  flex: 0 0 28%;
  max-width: 28%;
}

.booking-page .form-control,
.booking-page .form-select,
.booking-page textarea {
  width: 100%;
}

.booking-page .card-body .row.g-3 {
  row-gap: 1rem;
}

.booking-page .card-body .row.g-3 > [class*="col-"] {
  display: flex;
  flex-direction: column;
}

.booking-page .card-body .row.g-3 > [class*="col-"] > .form-label,
.booking-page .card-body .row.g-3 > [class*="col-"] > .position-relative,
.booking-page .card-body .row.g-3 > [class*="col-"] > input,
.booking-page .card-body .row.g-3 > [class*="col-"] > select,
.booking-page .card-body .row.g-3 > [class*="col-"] > textarea {
  width: 100%;
}

.booking-page .card.border .card-body.d-grid {
  gap: 10px !important;
}

.booking-page .card.border .card-body.d-grid .btn {
  width: 100%;
}

@media (max-width: 767.98px) {
  .booking-page .container-fluid {
    padding-left: 16px;
    padding-right: 16px;
  }
}

/* Global Agent Portal UI consistency */
.dashboard-main-body,
.auth-right {
  font-family: Poppins, sans-serif;
}

.dashboard-main-body .container-fluid {
  width: 100%;
  min-width: 0;
}

.dashboard-main-body h3,
.auth-right h4 {
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.dashboard-main-body h5,
.dashboard-main-body h6 {
  font-weight: 600;
  line-height: 1.35;
}

.dashboard-main-body .form-label,
.auth-right .form-label {
  font-weight: 500;
  font-size: 0.875rem;
  margin-bottom: 0.375rem;
}

.dashboard-main-body .form-control,
.dashboard-main-body .form-select,
.auth-right .form-control,
.auth-right .form-select {
  border-radius: 0.5rem;
  border-color: #e6e6e6;
  min-height: 2.813rem;
}

.dashboard-main-body .form-control:focus,
.dashboard-main-body .form-select:focus,
.auth-right .form-control:focus,
.auth-right .form-select:focus {
  border-color: #c6272a;
  box-shadow: 0 0 0 0.2rem rgba(198, 39, 42, 0.12);
}

.dashboard-main-body .form-control-sm,
.dashboard-main-body .form-select-sm {
  min-height: 2.25rem;
}

.dashboard-main-body .btn,
.auth-right .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border-radius: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.dashboard-main-body .btn iconify-icon,
.auth-right .btn iconify-icon {
  font-size: 1rem;
  line-height: 1;
}

.dashboard-main-body .card {
  border-radius: 12px;
  background: #fff;
}

.dashboard-main-body .card.border-0.shadow-sm {
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06) !important;
}

.dashboard-main-body .table,
.agent-table {
  --bs-table-bg: #fff;
  --bs-table-hover-bg: var(--neutral-50, #f8fafc);
}

.agent-table-wrap {
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.dashboard-main-body .bordered-table,
.agent-table.bordered-table {
  width: 100%;
  background: #fff;
}

.dashboard-main-body .bordered-table tbody tr:hover td,
.agent-table.bordered-table tbody tr:hover td {
  background-color: var(--neutral-50, #f8fafc);
}

.dashboard-main-body .table thead th,
.agent-table thead th,
.dashboard-main-body .bordered-table thead tr th {
  font-size: 0.9375rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  color: var(--text-primary-light, #111827) !important;
  white-space: nowrap;
  vertical-align: middle;
}

.dashboard-main-body .table td,
.agent-table td {
  vertical-align: middle;
  overflow-wrap: anywhere;
}

.dashboard-main-body .table tbody tr,
.agent-table tbody tr {
  height: 3.5rem;
}

.agent-kyc-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  min-width: 8.75rem;
}

.agent-kyc-actions__link {
  min-width: 4.25rem;
  text-align: left;
  line-height: 1.2;
}

.agent-kyc-actions__link--spacer {
  visibility: hidden;
  pointer-events: none;
  display: inline-block;
}

.agent-kyc-block__title {
  margin: 0 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #ececec;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary-light, #111827);
}

.agent-kyc-detail__label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary-light, #6b7280);
  margin-bottom: 0.25rem;
}

.agent-kyc-detail__value {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary-light, #111827);
  word-break: break-word;
}

.agent-kyc-note {
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #ececec;
  border-radius: 10px;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--text-secondary-light, #6b7280);
}

.dashboard-main-body .table td .text-end,
.dashboard-main-body .table th.text-end,
.dashboard-main-body .table td.text-end,
.agent-table th.text-end,
.agent-table td.text-end {
  white-space: nowrap;
}

.dashboard-main-body .table a:not(.btn):not(.agent-icon-btn),
.agent-table a:not(.btn):not(.agent-icon-btn),
.agent-table-link {
  color: var(--primary-600);
  font-weight: 600;
  text-decoration: none;
}

.dashboard-main-body .table a:not(.btn):not(.agent-icon-btn),
.agent-table a:not(.btn):not(.agent-icon-btn) {
  white-space: nowrap;
}

.dashboard-main-body .table a:not(.btn):not(.agent-icon-btn):hover,
.dashboard-main-body .table a:not(.btn):not(.agent-icon-btn):focus-visible,
.agent-table a:not(.btn):not(.agent-icon-btn):hover,
.agent-table a:not(.btn):not(.agent-icon-btn):focus-visible,
.agent-table-link:hover,
.agent-table-link:focus-visible {
  color: var(--primary-700);
  text-decoration: underline;
}

.dashboard-main-body input[type="file"].form-control {
  padding-top: 0.45rem;
  padding-bottom: 0.45rem;
}

.page-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  min-width: 0;
  flex: 0 0 auto;
}

.page-toolbar .btn {
  flex: 0 0 auto;
  min-height: 2.813rem;
}

.agent-page-header__meta {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  min-width: 0;
  flex: 0 1 auto;
}

.agent-back-btn {
  flex: 0 0 auto;
}

.agent-back-btn:focus-visible {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.35);
}

.agent-breadcrumb {
  min-width: 0;
  font-size: 0.875rem;
  line-height: 1.4;
}

.agent-breadcrumb > li {
  white-space: nowrap;
}

.agent-breadcrumb a {
  text-decoration: none;
  color: var(--text-secondary-light);
}

.agent-breadcrumb a:hover {
  color: var(--primary-600);
}

.agent-breadcrumb__current {
  color: var(--text-primary-light, #111827);
}

.agent-breadcrumb iconify-icon.icon {
  font-size: 1.125rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

.agent-settings-tabs,
.agent-tabs {
  max-width: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}

.agent-tabs .nav-item,
.agent-settings-tabs .nav-item {
  flex: 0 0 auto;
}

.agent-tabs .nav-link,
.bordered-tab .nav-link {
  white-space: nowrap;
}

.agent-tabs .nav-link:hover:not(.active),
.bordered-tab .nav-link:hover:not(.active) {
  color: var(--primary-600);
}

.agent-tabs::-webkit-scrollbar,
.agent-settings-tabs::-webkit-scrollbar,
.agent-booking-tabs::-webkit-scrollbar,
.agent-package-tabs::-webkit-scrollbar {
  height: 4px;
}

.agent-tabs::-webkit-scrollbar-thumb,
.agent-settings-tabs::-webkit-scrollbar-thumb,
.agent-booking-tabs::-webkit-scrollbar-thumb,
.agent-package-tabs::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 999px;
}

.agent-package-tabs::-webkit-scrollbar {
  height: 4px;
}

.agent-package-detail {
  max-width: 1480px;
  margin-inline: auto;
}

.agent-package-header {
  overflow: hidden;
}

.agent-package-header__grid {
  display: grid;
  grid-template-columns: minmax(240px, 360px) minmax(0, 1fr);
}

.agent-package-header__grid .catalog-image-wrap {
  height: 100%;
  min-height: 240px;
}

.agent-package-header__facts,
.agent-package-facts,
.agent-package-occupancy {
  display: grid;
  gap: 0.85rem 1rem;
}

.agent-package-header__facts,
.agent-package-facts {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.agent-package-facts--pricing {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  max-width: 28rem;
}

.agent-package-occupancy {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.agent-package-occupancy-item {
  border: 1px solid var(--neutral-200, #e5e7eb);
  border-radius: 0.75rem;
  padding: 0.9rem 1rem;
  background: #fff;
}

.agent-package-occupancy-heading {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin-bottom: 0.7rem;
}

.agent-package-occupancy-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  background: #f8e9eb;
  color: var(--primary, #c32032);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  flex-shrink: 0;
}

.agent-package-occupancy-prices {
  display: grid;
  gap: 0.35rem 0.75rem;
}

.agent-package-occupancy-price {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.agent-package-occupancy-price span {
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #6b7280;
}

.agent-package-occupancy-price strong {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #111827;
}

.agent-package-occupancy-price--rsp strong {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #6b7280;
}

.agent-package-fact-label {
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 0.2rem;
}

.agent-package-panel .card-header.agent-package-tabbar {
  background: #fff;
  border-bottom: 1px solid var(--neutral-200, #e5e7eb);
  padding: 0 8px;
}

.agent-package-tabs {
  width: 100%;
  max-width: 100%;
  margin-bottom: 0 !important;
  border-top: 0;
  display: flex;
}

.agent-package-tabs .nav-link {
  padding: 16px 24px;
}

.agent-package-section-title {
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 0.85rem;
}

.agent-package-empty {
  padding: 1.75rem 1rem;
  text-align: center;
  color: #6b7280;
  font-size: 0.9rem;
  border: 1px dashed #e5e7eb;
  border-radius: 0.75rem;
  background: #fafafa;
}

.agent-package-list {
  margin: 0;
  padding-left: 1.1rem;
}

.agent-package-list li + li {
  margin-top: 0.35rem;
}

.agent-package-feature-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.7rem;
}

.agent-package-feature-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  line-height: 1.45;
}

.agent-package-feature-icon {
  flex: 0 0 auto;
  font-size: 1.15rem;
  margin-top: 0.05rem;
  color: var(--primary-600);
}

.agent-package-city-title {
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--primary-600);
  margin: 0 0 0.75rem;
}

.agent-package-hotels section + section {
  margin-top: 1.35rem;
}

.agent-package-hotel-list,
.agent-package-flight-list {
  display: grid;
  gap: 0.85rem;
}

.agent-package-flight-leg {
  display: grid;
  gap: 0.35rem;
  padding: 0.85rem 0;
  border-bottom: 1px solid #eef0f3;
}

.agent-package-hotel {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 0.85rem 0;
  border-bottom: 1px solid #eef0f3;
}

.agent-package-hotel .catalog-image-wrap {
  width: 160px;
  flex: 0 0 160px;
  height: 120px;
  border-radius: 0.75rem;
}

.agent-package-hotel:last-child,
.agent-package-flight-leg:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.agent-package-hotel:first-child,
.agent-package-flight-leg:first-child {
  padding-top: 0;
}

.agent-package-hotel__meta,
.agent-package-flight-leg__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.85rem;
  margin-top: 0.35rem;
  color: #6b7280;
  font-size: 0.8125rem;
}

.agent-package-flight-leg__title {
  font-weight: 600;
}

.agent-package-itinerary {
  list-style: none;
  margin: 0;
  padding: 0;
}

.agent-package-itinerary-item {
  display: grid;
  grid-template-columns: 12px minmax(0, 1fr);
  gap: 0.2rem 0.85rem;
  position: relative;
  padding-bottom: 1.15rem;
}

.agent-package-itinerary-item:last-child {
  padding-bottom: 0;
}

.agent-package-itinerary-item:not(:last-child)::before {
  content: "";
  position: absolute;
  left: 5px;
  top: 14px;
  bottom: 0;
  width: 2px;
  background: var(--primary-100);
}

.agent-package-itinerary-dot {
  width: 10px;
  height: 10px;
  margin-top: 0.35rem;
  border-radius: 50%;
  background: var(--primary-600);
  box-shadow: 0 0 0 3px var(--primary-50);
  z-index: 1;
}

.agent-package-itinerary-day {
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--primary-700);
  margin-bottom: 0.15rem;
}

.agent-package-itinerary-city {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 0.15rem;
}

.agent-package-gallery {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.85rem;
}

.agent-package-gallery .catalog-image-wrap {
  border-radius: 0.75rem;
}

.agent-booking-detail {
  max-width: 1480px;
  margin-inline: auto;
}

.agent-booking-kicker {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 0.2rem;
}

.agent-booking-ref {
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
  word-break: break-word;
}

.agent-booking-section-title {
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 0.75rem;
}

.agent-booking-section-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.agent-passenger-form {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.85rem 1rem;
  align-items: start;
  margin-bottom: 1rem;
}

.agent-passenger-form__field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.agent-passenger-form .form-control,
.agent-passenger-form .form-select {
  width: 100%;
  min-width: 0;
}

.agent-passenger-form__span-2 {
  grid-column: span 2;
}

.agent-passenger-form__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}

@media (max-width: 1199.98px) {
  .agent-passenger-form {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575.98px) {
  .agent-passenger-form {
    grid-template-columns: minmax(0, 1fr);
  }

  .agent-passenger-form__span-2 {
    grid-column: auto;
  }
}

.agent-booking-field-label {
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 0.2rem;
}

.agent-booking-field-value {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #111827;
  line-height: 1.35;
  word-break: break-word;
}

.agent-booking-field-value .agent-status-badge {
  font-weight: 500;
}

.agent-booking-field-meta {
  font-size: 0.8125rem;
  color: #6b7280;
  margin-top: 0.25rem;
  line-height: 1.4;
  word-break: break-word;
}

.agent-booking-header-card .card-body {
  padding: 1rem 1.25rem 1.1rem;
}

.dashboard-main-body .agent-booking-header-card.card.border-0.shadow-sm .card-body {
  padding: 1rem 1.25rem 1.1rem;
}

.agent-booking-header-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  margin-bottom: 0.9rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #eef0f3;
}

.agent-booking-header-meta {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem 1rem;
  align-items: start;
}

@media (min-width: 1600px) {
  .agent-booking-header-meta {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
}

.agent-booking-panel-card .card-header.agent-booking-tabbar {
  background: #fff;
  border-bottom: 1px solid var(--neutral-200, #e5e7eb);
  padding: 0 8px;
}

.agent-booking-panel-card .card-body {
  padding: 1.1rem 1.25rem 1.25rem;
}

.dashboard-main-body .agent-booking-panel-card.card.border-0.shadow-sm .card-body {
  padding: 1.1rem 1.25rem 1.25rem;
}

.agent-booking-tabs {
  width: 100%;
  max-width: 100%;
  margin-bottom: 0 !important;
  border-top: 0;
  display: flex;
}

.agent-booking-tabs .nav-link {
  padding: 16px 24px;
}

.agent-booking-summary,
.agent-booking-readiness,
.agent-booking-payment-summary {
  display: grid;
  gap: 0.75rem;
  margin-bottom: 1.35rem;
}

.agent-booking-summary {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding: 0.85rem 1rem;
  border: 1px solid #eef0f3;
  border-radius: 0.75rem;
  background: #fafafa;
}

.agent-booking-summary--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.agent-booking-header-meta > *,
.agent-booking-summary > *,
.agent-booking-readiness > *,
.agent-booking-payment-summary > * {
  min-width: 0;
}

.agent-booking-readiness {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.agent-booking-payment-summary {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.agent-booking-tile {
  display: flex;
  flex-direction: column;
  padding: 0.85rem 0.95rem;
  border: 1px solid #eef0f3;
  border-radius: 0.75rem;
  background: #fff;
}

.agent-booking-tile .agent-booking-field-value {
  margin-top: 0.1rem;
}

.agent-booking-empty {
  padding: 1.75rem 1rem;
  text-align: center;
  color: #6b7280;
  font-size: 0.9rem;
  border: 1px dashed #e5e7eb;
  border-radius: 0.75rem;
  background: #fafafa;
}

.agent-booking-hotels {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  align-items: stretch;
}

.agent-booking-hotel-card {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-width: 0;
  height: 100%;
  overflow: hidden;
  border: 1px solid #eef0f3;
  border-radius: 1rem;
  background: #fff;
}

.agent-hotel-photo {
  width: 200px;
  height: 200px;
  flex: 0 0 200px;
  background: #f3f4f6;
}

.agent-hotel-photo .catalog-image-wrap {
  width: 200px !important;
  height: 200px !important;
}

.agent-booking-hotel-body {
  flex: 1 1 auto;
  min-width: 0;
  padding: 1rem 1rem 1.1rem;
  display: flex;
  flex-direction: column;
}

.agent-booking-hotel-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.9rem;
  min-height: 5.5rem;
}

.agent-booking-hotel-address {
  margin-top: 0.25rem;
  color: #6b7280;
  font-size: 0.8rem;
  line-height: 1.4;
  min-height: 2.8em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.agent-booking-hotel-address--empty {
  visibility: hidden;
}

.agent-booking-hotel-section + .agent-booking-hotel-section {
  margin-top: 0.85rem;
  padding-top: 0.85rem;
  border-top: 1px solid #f1f3f5;
}

.agent-booking-hotel-section-title {
  margin-bottom: 0.5rem;
  color: #6b7280;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.agent-booking-hotel-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.55rem 0.75rem;
}

.agent-booking-inline-actions {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 0.4rem;
}


.agent-booking-actions {
  min-width: 13.5rem;
}

.d-footer .row {
  --bs-gutter-y: 0.5rem;
}

.dashboard-main-body .table .btn-sm {
  min-height: 2rem;
}

.agent-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  letter-spacing: 0.01em;
  white-space: nowrap;
  max-width: 100%;
  line-height: 1.4;
}

.agent-person-cell {
  gap: 12px;
  min-width: 0;
}

.agent-table-avatar {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: var(--primary-50);
  color: var(--primary-600);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
}

.dashboard-main {
  overflow: visible;
}

.dashboard-main-body {
  overflow-x: hidden;
  max-width: 100%;
}

.agent-select {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.page-search {
  width: 16rem;
  max-width: 320px;
  flex: 0 1 16rem;
}

.page-toolbar .page-search,
.page-toolbar .agent-select {
  width: 16rem;
  max-width: 16rem;
}

.agent-select.page-search {
  max-width: 360px;
}

.agent-select .agent-select__control {
  min-height: 2.813rem;
}

.agent-select-menu-footer {
  border-top: 1px solid #eef0f3;
  padding: 0.35rem;
  background: #fff;
}

.agent-select-menu-action {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  border: 0;
  background: transparent;
  color: #c6272a;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  padding: 0.55rem 0.75rem;
  border-radius: 0.4rem;
  text-align: left;
}

.agent-select-menu-action:hover,
.agent-select-menu-action:focus-visible {
  background: rgba(198, 39, 42, 0.08);
  outline: none;
}

.agent-flash {
  margin-bottom: 1rem;
  overflow: hidden;
  min-width: 0;
}

.agent-alert-host {
  position: fixed;
  inset: 0;
  top: 0;
  right: 0;
  left: 0;
  bottom: auto;
  height: 5.5rem;
  z-index: 1080;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  pointer-events: none;
}

.agent-alert-host .agent-alert-toast,
.agent-alert-host .agent-flash {
  pointer-events: auto;
  max-width: 36rem;
  width: 100%;
  margin-bottom: 0;
  justify-content: space-between;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
  animation: agent-flash-center 0.65s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes agent-flash-center {
  0% {
    opacity: 0;
    transform: translateY(-28px) scale(0.86);
  }
  55% {
    opacity: 1;
    transform: translateY(6px) scale(1.04);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 575.98px) {
  .agent-alert-host {
    height: 5rem;
    padding: 0 0.75rem;
  }
}

.agent-flash-close,
.agent-flash .agent-flash-close {
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: inherit;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.agent-flash-close:hover,
.agent-flash-close:focus-visible,
.agent-flash .agent-flash-close:hover,
.agent-flash .agent-flash-close:focus-visible {
  background: rgba(15, 23, 42, 0.06);
  color: inherit;
}

.agent-page-loader .spinner-border {
  width: 2.25rem;
  height: 2.25rem;
}

.dashboard-main-body .card.border-0.shadow-sm .card-body {
  padding: 1.25rem;
}

.dashboard-main-body .package-card.card.border-0.shadow-sm .card-body {
  padding: 0.9rem 0.95rem 1rem;
}

.dashboard-main-body .list-group-item-action {
  text-align: left;
}

.border-gradient-tab .nav-link::before {
  border-top-color: var(--primary-600);
  background: linear-gradient(180deg, rgba(198, 39, 42, 0.12) 0%, rgba(198, 39, 42, 0.03) 100%);
}

.agent-icon-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: var(--primary-light);
  color: var(--primary-600);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  text-decoration: none;
  flex-shrink: 0;
}

.agent-icon-btn:hover,
.agent-icon-btn:focus-visible {
  color: var(--primary-700);
  background: var(--primary-100);
}

.agent-icon-btn:disabled {
  opacity: 0.45;
  pointer-events: none;
}

.agent-icon-btn iconify-icon {
  font-size: 1rem;
}

.agent-itinerary-notes {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 0;
  max-width: 220px;
}

.agent-itinerary-notes-preview {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #4b5563;
  font-size: 0.875rem;
}

.agent-modal-root {
  position: fixed;
  inset: 0;
  z-index: 2200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.agent-modal-backdrop {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: rgba(15, 23, 42, 0.55);
}

.agent-modal-root .modal-dialog {
  position: relative;
  z-index: 2;
  margin: 0;
  width: calc(100% - 2rem);
  max-width: 520px;
}

.agent-modal-root .modal-content {
  position: relative;
  background: #fff;
  border: 0;
  border-radius: 0.85rem;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.28);
  overflow: hidden;
}

.agent-modal-root .modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1.15rem 3rem 1rem 1.5rem;
  border-bottom: 1px solid #eef0f3;
}

.agent-modal-root .modal-title {
  margin: 0;
  padding: 0;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.4;
  color: #111827;
}

.agent-modal-root .modal-header .btn-close {
  position: absolute;
  top: 0.85rem;
  inset-inline-end: 0.85rem;
  margin: 0;
  padding: 0.5rem;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
}

.agent-modal-root .modal-body,
.agent-modal-body {
  padding: 1.25rem 1.5rem;
}

.agent-modal-root .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem 1.5rem 1.25rem;
  border-top: 1px solid #eef0f3;
}

.agent-notes-modal .modal-content,
.agent-notes-modal .modal-body,
.agent-modal-body {
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
}

.agent-upload-progress-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.45rem;
  font-size: 0.8125rem;
  color: #64748b;
}

.agent-upload-progress .progress {
  height: 0.7rem;
  border-radius: 999px;
  background: #f1f5f9;
  overflow: hidden;
}

.agent-upload-progress .progress-bar {
  background: var(--primary-600);
}

.agent-modal-root.agent-document-preview-modal .modal-dialog {
  width: min(920px, calc(100vw - 2rem));
  max-width: min(920px, calc(100vw - 2rem));
}

.agent-document-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  min-width: 0;
}

.agent-document-preview img,
.agent-document-preview iframe {
  display: block;
  width: 100%;
  max-width: 100%;
  border: 0;
  border-radius: 0.5rem;
  background: #f8fafc;
}

.agent-document-preview img {
  max-height: min(72vh, 640px);
  object-fit: contain;
}

.agent-document-preview iframe {
  height: min(72vh, 640px);
}

.agent-document-preview-nav {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  color: #64748b;
  font-size: 0.8125rem;
}

.agent-itinerary-notes-html {
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal;
  line-height: 1.75;
  color: #374151;
  font-size: 0.95rem;
}

.agent-itinerary-notes-heading {
  margin: 0 0 1rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: #111827;
  line-height: 1.45;
}

.agent-itinerary-notes-html p {
  margin: 0 0 1rem;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal;
}

.agent-itinerary-notes-html p:last-child {
  margin-bottom: 0;
}

.agent-profile-cover {
  height: 140px;
  width: 100%;
  object-fit: cover;
  display: block;
  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-800) 100%);
}

.agent-profile-avatar {
  width: 140px;
  height: 140px;
  border: 4px solid #fff;
  border-radius: 50%;
  background: var(--primary-50);
  color: var(--primary-600);
  font-size: 2rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: -70px;
}

.agent-profile-info-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 12px;
}

.agent-profile-info-list li:last-child {
  margin-bottom: 0;
}

.agent-profile-info-label {
  flex: 0 0 38%;
  max-width: 38%;
  font-weight: 600;
  color: var(--text-primary-light, #111827);
}

.agent-profile-info-value {
  flex: 1 1 auto;
  min-width: 0;
  color: var(--text-secondary-light, #6b7280);
  font-weight: 500;
  word-break: break-word;
}

.agent-profile-section {
  margin-bottom: 1.5rem;
}

.agent-profile-section:last-of-type {
  margin-bottom: 1.75rem;
}

.agent-profile-section__title {
  margin: 0 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #ececec;
  color: var(--text-primary-light, #111827);
  font-size: 0.95rem;
  font-weight: 600;
}

.agent-password-toggle {
  position: absolute;
  inset-inline-end: 1rem;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: var(--text-secondary-light, #6b7280);
  padding: 0;
  line-height: 1;
  cursor: pointer;
}

.profile-dropdown-close.agent-icon-btn {
  width: 1.75rem;
  height: 1.75rem;
  background: #fff;
}

.agent-notification-item {
  display: flex;
  align-items: flex-start;
  gap: 0.875rem;
  padding: 1rem;
  border: 1px solid #eef0f3;
  border-radius: 0.75rem;
  background: #fff;
  color: inherit;
  font: inherit;
  cursor: pointer;
  text-align: left;
  max-width: 100%;
  overflow: hidden;
}

.agent-notification-item.is-unread {
  background: #fdecec;
  border-color: #f0a8aa;
}

.agent-notification-item:hover,
.agent-notification-item:focus-visible {
  border-color: #f0a8aa;
}

.min-w-0 {
  min-width: 0;
}

.auth,
.auth-left,
.auth-right,
.auth-form-card {
  min-width: 0;
}

.auth-right {
  overflow-x: hidden;
}

.form-check.style-check .form-check-label {
  min-width: 0;
  white-space: normal;
}

.auth-left {
  overflow: hidden;
}

.auth-hero-image {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

.auth-form-card {
  width: 100%;
}

.auth-password-field {
  position: relative;
}

.auth-password-input {
  padding-inline-end: 2.75rem;
}

.auth-password-toggle {
  position: absolute;
  top: 50%;
  inset-inline-end: 1rem;
  transform: translateY(-50%);
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-secondary-light, #6b7280);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
}

.auth-form-meta {
  min-width: 0;
}

.auth-wizard-steps {
  max-width: 100%;
}

.form-wizard,
.form-wizard-header {
  min-width: 0;
  max-width: 100%;
}

.form-wizard .form-group .btn {
  white-space: nowrap;
}

.sidebar-close-btn {
  z-index: 4;
}

@media (max-width: 1399.98px) {
  .navbar-search-field {
    width: min(16rem, 100%);
  }

  .navbar-shortcut-label {
    display: none;
  }

  .navbar-shortcut {
    padding: 0.4rem 0.55rem;
  }

  .agent-booking-readiness {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .agent-booking-payment-summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1199.98px) {
  .navbar-search-field {
    width: min(12rem, 100%);
  }

  .dropdown-menu.profile-dropdown-menu {
    width: min(18.5rem, calc(100vw - 1.25rem));
    max-width: min(18.5rem, calc(100vw - 1.25rem));
  }

  .agent-booking-hotels {
    grid-template-columns: 1fr;
  }

  .agent-package-header__facts,
  .agent-package-facts,
  .agent-package-occupancy {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .agent-package-gallery {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .agent-booking-summary,
  .agent-booking-summary--3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 991.98px) {
  .auth-right {
    width: 100%;
    padding: 2rem 1.25rem;
  }

  .auth-form-card {
    max-width: 100%;
  }

  .booking-page .col-lg-8,
  .booking-page .col-lg-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .agent-booking-readiness,
  .agent-booking-payment-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .agent-booking-hotel-card {
    flex-direction: column;
  }

  .agent-hotel-photo,
  .agent-hotel-photo .catalog-image-wrap {
    width: 200px !important;
    height: 200px !important;
    flex-basis: 200px;
    margin: 0.85rem auto 0;
    border-radius: 0.75rem;
    overflow: hidden;
  }

  .agent-package-header__grid {
    grid-template-columns: 1fr;
  }

  .agent-package-header__grid .catalog-image-wrap {
    min-height: 220px;
    max-height: 240px;
  }
}

@media (max-width: 767.98px) {
  .dashboard-main-body .container-fluid {
    padding-left: 16px;
    padding-right: 16px;
  }

  .navbar-header {
    padding: 0.75rem 1rem;
  }

  .navbar-header-actions {
    gap: 0.5rem;
  }

  .page-search {
    max-width: 100%;
    width: 100%;
    flex: 1 1 100%;
  }

  .dashboard-main-body .d-flex.flex-wrap.justify-content-between > .page-search,
  .dashboard-main-body .d-flex.flex-wrap.justify-content-between > .agent-select {
    max-width: 100%;
  }

  .dashboard-main-body .d-flex.flex-wrap.align-items-center.gap-2 > .page-search,
  .page-toolbar .page-search,
  .page-toolbar .agent-select {
    max-width: 100%;
    flex: 1 1 100%;
  }

  .page-toolbar {
    width: 100%;
    flex-wrap: wrap;
    justify-content: stretch;
  }

  .agent-page-header__meta {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .package-catalog-head .agent-page-header__meta:has(.page-head-actions) {
    justify-content: flex-end;
  }

  .auth-right {
    padding: 1.5rem 1rem;
  }

  .auth-form-meta {
    flex-direction: column;
  }

  .form-wizard .form-group .btn {
    flex: 1 1 auto;
    min-width: 0;
  }

  .dropdown-menu.profile-dropdown-menu {
    width: min(17.5rem, calc(100vw - 1rem));
    min-width: 0;
    max-width: calc(100vw - 1rem);
  }

  .agent-settings-tabs,
  .agent-tabs,
  .agent-booking-tabs,
  .agent-package-tabs {
    width: 100%;
  }

  .agent-settings-tabs .nav-link,
  .agent-tabs .nav-link,
  .agent-booking-tabs .nav-link,
  .agent-package-tabs .nav-link {
    padding: 12px 16px;
  }

  .agent-package-header__facts,
  .agent-package-facts,
  .agent-package-occupancy,
  .agent-package-facts--pricing {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .agent-package-gallery {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .agent-package-hotel {
    flex-direction: column;
  }

  .agent-package-hotel .catalog-image-wrap {
    width: 100%;
    flex-basis: auto;
    height: 180px;
  }

  .agent-profile-avatar {
    width: 112px;
    height: 112px;
    font-size: 1.5rem;
    margin-top: -56px;
  }

  .agent-profile-info-label,
  .agent-profile-info-value {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .agent-booking-header-meta,
  .agent-booking-summary,
  .agent-booking-summary--3,
  .agent-booking-readiness,
  .agent-booking-payment-summary,
  .agent-booking-hotel-meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .agent-booking-ref {
    font-size: 1.25rem;
  }

  .agent-booking-inline-actions {
    justify-content: flex-start;
  }

  .agent-breadcrumb {
    max-width: 100%;
  }
}

@media (max-width: 575.98px) {
  .navbar-action-btn,
  .profile-dropdown-toggle {
    width: 2.25rem;
    height: 2.25rem;
  }

  .form-wizard .form-group {
    justify-content: stretch !important;
  }

  .form-wizard .form-group .btn {
    width: 100%;
  }

  .dashboard-main-body .btn {
    white-space: normal;
  }

  .agent-hotel-photo,
  .agent-hotel-photo .catalog-image-wrap {
    width: 200px !important;
    height: 200px !important;
  }

  .agent-booking-actions {
    min-width: 11rem;
  }

  .agent-booking-header-meta,
  .agent-booking-summary,
  .agent-booking-summary--3,
  .agent-booking-readiness,
  .agent-booking-payment-summary {
    grid-template-columns: 1fr 1fr;
  }

  .agent-booking-hotel-meta {
    grid-template-columns: 1fr 1fr;
  }

  .page-toolbar .btn {
    width: auto;
  }

  .agent-page-header__meta {
    justify-content: flex-start;
  }

  .agent-breadcrumb {
    justify-content: flex-start;
  }
}

@media (max-width: 479.98px) {
  .agent-booking-header-meta,
  .agent-booking-summary,
  .agent-booking-summary--3,
  .agent-booking-readiness,
  .agent-booking-payment-summary,
  .agent-booking-hotel-meta {
    grid-template-columns: 1fr;
  }

  .agent-booking-inline-actions {
    width: 100%;
  }

  .agent-booking-inline-actions .btn {
    flex: 1 1 auto;
  }
}

.agent-voucher-page {
  max-width: 980px;
  margin-inline: auto;
}

.agent-voucher-sheet {
  background: #fff;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.06);
  overflow: hidden;
}

.agent-voucher-letterhead {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem 1.5rem;
  padding: 1.35rem 1.5rem 1.2rem;
  border-bottom: 3px solid var(--brand, #c6272a);
  background: #fff;
}

.agent-voucher-brand {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  min-width: 0;
}

.agent-voucher-logo {
  width: auto;
  height: 48px;
  max-width: 168px;
  object-fit: contain;
}

.agent-voucher-brand-name {
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.2;
  color: #111827;
}

.agent-voucher-brand-tag {
  font-size: 0.78rem;
  color: #6b7280;
  margin-top: 0.15rem;
}

.agent-voucher-docmark {
  text-align: right;
  min-width: 12rem;
}

.agent-voucher-docmark-title {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--brand, #c6272a);
}

.agent-voucher-docmark-ref {
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.25;
  color: #111827;
  margin-top: 0.15rem;
}

.agent-voucher-docmark-meta {
  font-size: 0.8rem;
  color: #6b7280;
  margin-top: 0.15rem;
}

.agent-voucher-meta {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.85rem 1rem;
  padding: 1.15rem 1.5rem;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}

.agent-voucher-meta--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  background: transparent;
  border-bottom: 0;
  padding: 0;
}

.agent-voucher-field {
  min-width: 0;
}

.agent-voucher-label {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 0.2rem;
}

.agent-voucher-value {
  font-size: 0.95rem;
  font-weight: 600;
  color: #111827;
  line-height: 1.35;
  word-break: break-word;
}

.agent-voucher-section {
  padding: 1.1rem 1.5rem 0.25rem;
}

.agent-voucher-section-title {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--brand, #c6272a);
  margin: 0 0 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #f3f4f6;
}

.agent-voucher-flights {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.85rem;
}

.agent-voucher-flights--split {
  grid-template-columns: 1fr 1fr;
}

.agent-voucher-flight,
.agent-voucher-hotel {
  border: 1px solid #ececec;
  border-radius: 10px;
  padding: 0.9rem 1rem;
  background: #fff;
}

.agent-voucher-flight-head,
.agent-voucher-flight-foot {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.35rem 0.75rem;
}

.agent-voucher-flight-leg {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand, #c6272a);
}

.agent-voucher-flight-meta,
.agent-voucher-hotel-stay,
.agent-voucher-flight-foot,
.agent-voucher-note,
.agent-voucher-empty,
.agent-voucher-footer {
  font-size: 0.82rem;
  color: #4b5563;
}

.agent-voucher-route {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 0.6rem;
  margin: 0.75rem 0 0.7rem;
}

.agent-voucher-airport-kicker {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #9ca3af;
}

.agent-voucher-airport-name {
  font-size: 0.92rem;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
}

.agent-voucher-airport--end {
  text-align: right;
}

.agent-voucher-route-line {
  width: 3.25rem;
  height: 2px;
  background: #e5e7eb;
  position: relative;
}

.agent-voucher-route-line::after {
  content: "";
  position: absolute;
  right: -1px;
  top: 50%;
  width: 7px;
  height: 7px;
  border-top: 2px solid #c6272a;
  border-right: 2px solid #c6272a;
  transform: translateY(-50%) rotate(45deg);
}

.agent-voucher-flight-foot {
  border-top: 1px dashed #ececec;
  padding-top: 0.55rem;
}

.agent-voucher-hotels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.85rem;
}

.agent-voucher-hotel-city {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand, #c6272a);
}

.agent-voucher-hotel-name {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin: 0.2rem 0 0.25rem;
}

.agent-voucher-note {
  margin: 0.75rem 0 0;
}

.agent-voucher-empty {
  margin: 0 0 0.75rem;
}

.agent-voucher-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0.75rem;
}

.agent-voucher-table th,
.agent-voucher-table td {
  border-bottom: 1px solid #f0f0f0;
  padding: 0.55rem 0.4rem;
  text-align: left;
  font-size: 0.88rem;
  vertical-align: top;
}

.agent-voucher-table th {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  background: #fafafa;
}

.agent-voucher-table td {
  color: #111827;
  font-weight: 500;
}

.agent-voucher-footer {
  margin-top: 0.5rem;
  padding: 1rem 1.5rem 1.25rem;
  border-top: 1px solid #eee;
}

.agent-voucher-footer p {
  margin: 0;
}

.agent-voucher-footer p + p {
  margin-top: 0.25rem;
}

[data-theme="dark"] .agent-voucher-sheet,
[data-theme="dark"] .agent-voucher-letterhead,
[data-theme="dark"] .agent-voucher-flight,
[data-theme="dark"] .agent-voucher-hotel,
[data-theme="dark"] .agent-voucher-table th {
  background: #fff;
}

[data-theme="dark"] .agent-voucher-brand-name,
[data-theme="dark"] .agent-voucher-docmark-ref,
[data-theme="dark"] .agent-voucher-value,
[data-theme="dark"] .agent-voucher-airport-name,
[data-theme="dark"] .agent-voucher-hotel-name,
[data-theme="dark"] .agent-voucher-table td {
  color: #111827;
}

@media (max-width: 767.98px) {
  .agent-voucher-meta,
  .agent-voucher-meta--3,
  .agent-voucher-flights--split,
  .agent-voucher-hotels {
    grid-template-columns: 1fr 1fr;
  }

  .agent-voucher-docmark {
    text-align: left;
  }
}

@media (max-width: 575.98px) {
  .agent-voucher-meta,
  .agent-voucher-meta--3,
  .agent-voucher-flights--split,
  .agent-voucher-hotels,
  .agent-voucher-route {
    grid-template-columns: 1fr;
  }

  .agent-voucher-airport--end {
    text-align: left;
  }

  .agent-voucher-route-line {
    width: 100%;
    margin: 0.15rem 0;
  }
}

@media print {
  @page {
    size: A4;
    margin: 10mm;
  }

  html,
  body.agent-voucher-open,
  body.agent-voucher-open .app-shell,
  body.agent-voucher-open .dashboard-main,
  body.agent-voucher-open .dashboard-main-body,
  body.agent-voucher-open .agent-voucher-page {
    background: #fff !important;
    color: #111827 !important;
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    box-shadow: none !important;
  }

  body.agent-voucher-open .sidebar,
  body.agent-voucher-open .navbar-header,
  body.agent-voucher-open .d-footer,
  body.agent-voucher-open .agent-voucher-toolbar,
  body.agent-voucher-open .sidebar-close-btn {
    display: none !important;
  }

  body.agent-voucher-open .dashboard-main,
  body.agent-voucher-open.app-shell.sidebar-collapsed .dashboard-main,
  .app-shell.sidebar-collapsed .dashboard-main {
    margin-inline-start: 0 !important;
  }

  .agent-voucher-sheet {
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    overflow: visible !important;
  }

  .agent-voucher-section,
  .agent-voucher-flight,
  .agent-voucher-hotel,
  .agent-voucher-table,
  .agent-voucher-letterhead {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .agent-voucher-flights--split,
  .agent-voucher-hotels,
  .agent-voucher-meta,
  .agent-voucher-meta--3 {
    grid-template-columns: 1fr 1fr !important;
  }

  * {
    print-color-adjust: exact !important;
  }
}

.agent-otp-row {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.agent-otp-input {
  width: 52px;
  height: 56px;
  flex: 0 0 52px;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  line-height: 56px;
  padding: 0;
  border: 1px solid #dbe0e6;
  border-radius: 12px;
  background: #f7f8fa;
  color: #111827;
  caret-color: #c6272a;
  box-shadow: none;
}

.agent-otp-input:focus {
  border-color: #c6272a;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(198, 39, 42, 0.16);
  outline: none;
}

.agent-otp-input.is-filled {
  border-color: #c6272a;
  background: #fff;
}

.agent-otp-input:-webkit-autofill,
.agent-otp-input:-webkit-autofill:hover,
.agent-otp-input:-webkit-autofill:focus {
  -webkit-text-fill-color: #111827;
  -webkit-box-shadow: 0 0 0 1000px #fff inset;
  border-color: #c6272a;
  -webkit-transition: background-color 9999s ease-out;
  transition: background-color 9999s ease-out;
}

.agent-onboarding-page .form-wizard-list__item.activated .count {
  background-color: var(--success-main, #45b369);
  border-color: var(--success-main, #45b369);
  color: #fff;
}

.agent-onboarding-page .form-wizard-list__item.activated .text {
  color: var(--success-main, #45b369);
}

.agent-onboarding-page .form-wizard-list__item.activated .form-wizard-list__line::before {
  background-color: var(--success-main, #45b369);
}

.agent-onboarding-art {
  padding: 28px 12px 8px;
}

.agent-onboarding-art__svg {
  width: min(560px, 100%);
  height: auto;
  display: block;
  margin: 0 auto 12px;
}

.agent-empty-art {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.agent-empty-art__svg {
  width: min(280px, 100%);
  height: auto;
  display: block;
  margin: 0 auto 1rem;
}

.password-strength {
  margin-top: 10px;
}

.password-strength__meter {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-bottom: 8px;
}

.password-strength__bar {
  height: 6px;
  border-radius: 999px;
  background: #e5e7eb;
}

.password-strength__bar.is-filled {
  background: #c6272a;
}

.password-strength.is-fair .password-strength__bar.is-filled {
  background: #e6a23c;
}

.password-strength.is-good .password-strength__bar.is-filled {
  background: #3b82f6;
}

.password-strength.is-strong .password-strength__bar.is-filled {
  background: #45b369;
}

.password-strength__label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
}

.password-strength.is-weak .password-strength__label {
  color: #c6272a;
}

.password-strength.is-fair .password-strength__label {
  color: #b45309;
}

.password-strength.is-good .password-strength__label {
  color: #1d4ed8;
}

.password-strength.is-strong .password-strength__label {
  color: #15803d;
}

.password-strength__checks {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 4px;
}

.password-strength__checks li {
  position: relative;
  padding-left: 18px;
  font-size: 12px;
  color: #6b7280;
}

.password-strength__checks li::before {
  content: "○";
  position: absolute;
  left: 0;
  top: 0;
  color: #9ca3af;
}

.password-strength__checks li.is-passed {
  color: #15803d;
}

.password-strength__checks li.is-passed::before {
  content: "✓";
  color: #45b369;
}

.agent-onboarding-footer {
  background: #fff;
  border-top: 1px solid #ececec;
}

.agent-onboarding-shell {
  width: 100%;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 16px;
  padding: 24px 24px 8px;
}

.agent-onboarding-shell > .card {
  border-color: #f0f0f0;
  box-shadow: none;
}

.agent-onboarding-page .alert.radius-4 {
  border-radius: 4px;
}

@media (max-width: 767.98px) {
  .agent-onboarding-page .form-wizard-list__item .text {
    white-space: nowrap;
  }

  .agent-onboarding-shell {
    padding: 16px 16px 4px;
  }

  .agent-onboarding-page .card-body {
    padding: 16px;
  }
}

@media (max-width: 575.98px) {
  .agent-otp-input {
    width: 42px;
    height: 48px;
    flex-basis: 42px;
    font-size: 18px;
    line-height: 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wCAAwC;EACxC,8CAA8C;EAC9C,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,6CAA6C;EAC7C,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+HAA+H;EAC/H,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qGAAqG;AACvG;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,6EAA6E;EAC/E;AACF;;AAEA;EACE;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B;;;;;GAKC;EACD,2DAA2D;AAC7D;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,yCAAyC;EACzC,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,uCAAuC;EACvC,0CAA0C;EAC1C,gBAAgB;EAChB,wBAAwB;EACxB,yCAAyC;EACzC,sBAAsB;EACtB,8CAA8C;EAC9C,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,8CAA8C;AAChD;;AAEA;;;EAGE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,yCAAyC;EACzC,UAAU;EACV,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;;;IAGE,mBAAmB;IACnB,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;EAIE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,oBAAoB;EACpB,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,uCAAuC;EACvC,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,yCAAyC;EACzC,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;AACvC;;EAEE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;;;EAIE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;;EAEE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;;EAGE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,oDAAoD;EACpD,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;EAME,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;EAIE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,cAAc;EACd,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,8CAA8C;EAC9C,kEAAkE;AACpE;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;;EAIE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,6FAA6F;AAC/F;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mFAAmF;AACrF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;EACvB,2CAA2C;EAC3C,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,cAAc;EACd,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0CAA0C;IAC1C,8CAA8C;EAChD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,uCAAuC;IACvC,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;;;;IAIE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;;;;;;IAME,gDAAgD;EAClD;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;IAKE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;;;;;IAME,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;;;;;EAME,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE;;;;IAIE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;;;;;;IAME,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;;;;;IAKE,wBAAwB;EAC1B;;EAEA;;;IAGE,iCAAiC;EACnC;;EAEA;IACE,oBAAoB;IACpB,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;;;;IAKE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;;;;IAIE,yCAAyC;EAC3C;;EAEA;IAEE,oCAAoC;EACtC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;EAGE,gCAAgC;EAChC,2CAA2C;EAC3C,qBAAqB;EACrB,mDAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[":root {\n  --primary-50: #fdecec;\n  --primary-100: #f8d0d1;\n  --primary-200: #f0a8aa;\n  --primary-300: #e57a7d;\n  --primary-400: #d64d52;\n  --primary-500: #c6272a;\n  --primary-600: #c6272a;\n  --primary-700: #a81f22;\n  --primary-800: #8a191c;\n  --primary-900: #6b1215;\n  --primary-light: rgba(198, 39, 42, 0.15);\n  --primary-light-white: rgba(198, 39, 42, 0.25);\n  --brand: #c6272a;\n  --bs-primary: #c6272a;\n  --bs-primary-rgb: 198, 39, 42;\n  --bs-link-color: #c6272a;\n  --bs-link-hover-color: #a81f22;\n}\n\n[data-theme=\"dark\"] {\n  --primary-50: rgba(198, 39, 42, 0.12);\n}\n\nhtml,\nbody {\n  font-family: Poppins, sans-serif;\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #c6272a;\n  --bs-btn-border-color: #c6272a;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #a81f22;\n  --bs-btn-hover-border-color: #a81f22;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #8a191c;\n  --bs-btn-active-border-color: #8a191c;\n  --bs-btn-disabled-bg: #c6272a;\n  --bs-btn-disabled-border-color: #c6272a;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #c6272a;\n  --bs-btn-border-color: #c6272a;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #c6272a;\n  --bs-btn-hover-border-color: #c6272a;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #a81f22;\n  --bs-btn-active-border-color: #a81f22;\n}\n\n.text-primary,\na.text-primary {\n  color: #c6272a !important;\n}\n\n.bg-primary {\n  background-color: #c6272a !important;\n}\n\n.border-primary {\n  border-color: #c6272a !important;\n}\n\n.bg-primary-subtle {\n  background-color: #fdecec !important;\n}\n\n.sidebar-logo img.light-logo,\n.sidebar-logo img.dark-logo {\n  max-width: 168px;\n  max-height: 48px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.sidebar-logo img.logo-icon {\n  width: 42px;\n  height: 42px;\n  object-fit: contain;\n}\n\n.auth-brand-logo {\n  max-width: 210px;\n  height: auto;\n  object-fit: contain;\n}\n\n.agent-onboarding-logo {\n  display: block;\n  max-width: 132px;\n  max-height: 44px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.agent-onboarding-page .form-check.style-check {\n  gap: 0.75rem;\n}\n\n.agent-onboarding-page .form-check.style-check .form-check-input {\n  width: 1.15rem;\n  height: 1.15rem;\n  margin-top: 0.2rem;\n  flex-shrink: 0;\n}\n\n.agent-onboarding-page .form-check.style-check .form-check-label {\n  padding-top: 0.05rem;\n  line-height: 1.5;\n}\n\n.catalog-card {\n  overflow: hidden;\n  border-radius: 16px;\n}\n\n.catalog-image-wrap {\n  width: 100%;\n  overflow: hidden;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.catalog-image-wrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  display: block;\n}\n\n.catalog-card .card-title {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: 2.5em;\n  line-height: 1.25;\n}\n\n.catalog-card .card-body {\n  padding: 1.1rem 1.15rem 1.2rem;\n}\n\n.package-catalog-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.25rem;\n  align-items: stretch;\n}\n\n.package-card {\n  min-width: 0;\n}\n\n.package-card__image,\n.package-card .catalog-image-wrap.package-card__image,\n.package-card__image-skeleton {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16 / 10;\n  flex-shrink: 0;\n}\n\n.package-card__image-skeleton {\n  display: block;\n  border-radius: 0 !important;\n}\n\n.package-card .card-body {\n  padding: 0.9rem 0.95rem 1rem;\n  gap: 0.7rem;\n}\n\n.package-card__code {\n  letter-spacing: 0.04em;\n  line-height: 1.3;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.package-card__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.package-card .card-title,\n.package-card__name {\n  width: 100%;\n  min-height: 1.5em;\n  max-height: 1.5em;\n  font-size: 0.98rem;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.25;\n}\n\n.package-card .agent-status-badge {\n  padding: 0.15rem 0.7rem;\n  font-size: 0.7rem;\n}\n\n.package-card__meta {\n  display: grid;\n  gap: 0.28rem;\n}\n\n.package-card__row {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n.package-card__label {\n  color: #6b7280;\n  font-weight: 500;\n  font-size: 0.72rem;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.package-card__value {\n  color: #111827;\n  font-weight: 600;\n  text-align: right;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.package-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding-top: 0.55rem;\n  border-top: 1px solid #eef0f3;\n}\n\n.package-card__prices {\n  min-width: 0;\n}\n\n.package-card__book {\n  flex: 0 0 auto;\n  min-width: 4.75rem;\n}\n\n.package-card__net {\n  color: var(--primary-600);\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.package-catalog-head {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.15rem 1.25rem 1.2rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);\n  min-width: 0;\n  max-width: 100%;\n}\n\n.package-catalog-header {\n  margin-bottom: 1rem !important;\n}\n\n.page-head-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.page-head-actions .page-toolbar {\n  width: 100%;\n}\n\n.package-catalog-head .page-head-actions {\n  margin-bottom: 0;\n}\n\n.package-catalog-head .page-head-actions .page-toolbar {\n  width: auto;\n}\n\n.package-filter-bar {\n  display: grid;\n  grid-template-columns: minmax(12rem, 1.35fr) minmax(8.5rem, 1fr) minmax(8rem, 0.9fr) minmax(10.5rem, 1.1fr) minmax(8.5rem, 1fr);\n  gap: 0.75rem 0.85rem;\n  align-items: end;\n  min-width: 0;\n}\n\n.package-filter-bar--hotels {\n  grid-template-columns: minmax(12rem, 1.4fr) minmax(9rem, 1fr) minmax(9rem, 1fr) minmax(11rem, 1.15fr);\n}\n\n.package-filter-bar--flights {\n  grid-template-columns: minmax(16rem, 28rem);\n}\n\n.package-filter-bar__field {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.package-filter-bar__label {\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6b7280;\n  letter-spacing: 0.02em;\n}\n\n.package-filter-bar .form-control,\n.package-filter-bar .agent-select {\n  width: 100%;\n  min-width: 0;\n}\n\n.package-filter-range {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.package-filter-range .form-control {\n  min-width: 0;\n  flex: 1 1 0;\n}\n\n.package-filter-range-sep {\n  color: #9ca3af;\n  font-weight: 600;\n  flex: 0 0 auto;\n}\n\n@media (min-width: 768px) {\n  .package-catalog-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1200px) {\n  .package-catalog-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1650px) {\n  .package-catalog-grid {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .package-filter-bar,\n  .package-filter-bar--hotels {\n    grid-template-columns: minmax(11rem, 1fr) minmax(8rem, 1fr) minmax(8rem, 1fr);\n  }\n}\n\n@media (max-width: 991.98px) {\n  .package-filter-bar,\n  .package-filter-bar--hotels {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 767.98px) {\n  .package-catalog-head {\n    padding: 1rem 1rem 1.1rem;\n  }\n\n  .package-filter-bar,\n  .package-filter-bar--hotels,\n  .package-filter-bar--flights {\n    grid-template-columns: 1fr;\n  }\n}\n\n.agent-skeleton {\n  display: block;\n  background-color: #e8eaed;\n  position: relative;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.agent-skeleton::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.55) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: agent-skeleton-shimmer 1.5s ease-in-out infinite;\n}\n\n@keyframes agent-skeleton-shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .agent-skeleton::after {\n    animation: none;\n  }\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  width: 100%;\n  min-width: 0;\n  overflow-x: hidden;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n.dashboard-main,\n.dashboard-main-body,\n.booking-page,\n.booking-page .container-fluid,\n.booking-page .row,\n.booking-page .col-lg-8,\n.booking-page .col-lg-4,\n.booking-page .card,\n.booking-page .card-body {\n  min-width: 0;\n}\n\n.navbar-search {\n  position: relative;\n  display: none;\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\n@media (min-width: 992px) {\n  .navbar-search {\n    display: block;\n  }\n}\n\n.navbar-search-field {\n  position: relative;\n  display: block;\n  width: min(24.25rem, 100%);\n}\n\n.navbar-search input {\n  display: block;\n  width: 100%;\n  height: 2.5rem;\n  background-color: var(--neutral-50);\n  border: 1px solid var(--input-form-light);\n  border-radius: 0.5rem;\n  padding-block: 0.3125rem;\n  padding-inline-start: 2.5rem;\n  padding-inline-end: 1rem;\n  color: var(--text-primary-light);\n}\n\n.navbar-search input:focus {\n  border-color: var(--primary-600);\n  outline: none;\n}\n\n.navbar-search input[type=\"search\"]::-webkit-search-decoration,\n.navbar-search input[type=\"search\"]::-webkit-search-cancel-button,\n.navbar-search input[type=\"search\"]::-webkit-search-results-button,\n.navbar-search input[type=\"search\"]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.navbar-search-icon {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  inset-inline-start: 0;\n  width: 2.5rem;\n  height: 2.5rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-secondary-light, #6b7280);\n  font-size: 1.125rem;\n  line-height: 1;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.navbar-search-icon iconify-icon {\n  display: block;\n  width: 1.125rem;\n  height: 1.125rem;\n  color: inherit;\n}\n\n.navbar-search-results {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  left: 0;\n  width: min(28rem, calc(100vw - 1.5rem));\n  max-height: min(28rem, calc(100vh - 6rem));\n  overflow-y: auto;\n  background: var(--white);\n  border: 1px solid var(--input-form-light);\n  border-radius: 0.75rem;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.14);\n  z-index: 1080;\n  padding: 0.5rem 0;\n}\n\n.navbar-search-status {\n  padding: 0.875rem 1rem;\n  color: var(--text-secondary-light);\n  font-size: 0.8125rem;\n}\n\n.navbar-search-group + .navbar-search-group {\n  border-top: 1px solid var(--input-form-light);\n  margin-top: 0.25rem;\n  padding-top: 0.25rem;\n}\n\n.navbar-search-group-title {\n  padding: 0.5rem 1rem 0.25rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-secondary-light);\n}\n\n.navbar-search-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.625rem 1rem;\n  color: var(--text-primary-light);\n  text-decoration: none;\n}\n\n.navbar-search-item:hover,\n.navbar-search-item.is-active {\n  background: var(--primary-50);\n  color: var(--primary-600);\n}\n\n.navbar-search-item-icon {\n  width: 1.75rem;\n  height: 1.75rem;\n  flex: 0 0 1.75rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: var(--neutral-200);\n  color: var(--primary-600);\n  font-size: 0.95rem;\n}\n\n.navbar-search-item-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n  min-width: 0;\n}\n\n.navbar-search-item-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.navbar-search-item-subtitle {\n  font-size: 0.75rem;\n  color: var(--text-secondary-light);\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.navbar-search-more {\n  display: block;\n  padding: 0.375rem 1rem 0.625rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--primary-600);\n  text-decoration: none;\n}\n\n.navbar-search-more:hover {\n  text-decoration: underline;\n}\n\n.navbar-header .col-auto > .d-flex {\n  flex-wrap: nowrap;\n}\n\n.sidebar-toggle,\n.sidebar-mobile-toggle {\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.sidebar-toggle {\n  display: none;\n}\n\n@media (min-width: 1200px) {\n  .sidebar-toggle {\n    display: inline-flex;\n  }\n}\n\n.sidebar-mobile-toggle {\n  display: inline-flex;\n}\n\n@media (min-width: 1200px) {\n  .sidebar-mobile-toggle {\n    display: none;\n  }\n}\n\n.sidebar-menu .menu-item,\n.sidebar-logout {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 2.5rem;\n  width: 100%;\n  overflow: visible;\n}\n\n.sidebar-menu .menu-item .menu-icon,\n.sidebar-logout .menu-icon {\n  width: 18px;\n  min-width: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-inline-end: 0;\n  line-height: 1;\n}\n\n.sidebar-menu .menu-item .menu-icon iconify-icon,\n.sidebar-logout .menu-icon iconify-icon {\n  width: 16px;\n  height: 16px;\n  font-size: 16px;\n}\n\n.sidebar-menu .menu-item .menu-label,\n.sidebar-logout .menu-label {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.sidebar-menu .menu-item .menu-label,\n.sidebar-menu .menu-item .menu-icon,\n.sidebar-logout .menu-label,\n.sidebar-logout .menu-icon {\n  pointer-events: none;\n}\n\n.sidebar-menu .menu-item .sidebar-tooltip {\n  display: none;\n}\n\n.app-shell.sidebar-collapsed .sidebar .menu-item {\n  justify-content: center;\n  gap: 0;\n  padding-inline: 0;\n}\n\n.app-shell.sidebar-collapsed .sidebar .menu-item .menu-icon {\n  display: inline-flex !important;\n  margin-inline-end: 0 !important;\n}\n\n.app-shell.sidebar-collapsed .sidebar .menu-item .menu-label {\n  display: none !important;\n}\n\n.app-shell.sidebar-collapsed .sidebar .menu-item .sidebar-tooltip {\n  position: absolute;\n  inset-inline-start: calc(100% + 8px);\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  padding: 0.375rem 0.625rem;\n  border-radius: 0.5rem;\n  background: var(--neutral-900);\n  color: #fff;\n  font-size: 0.8125rem;\n  line-height: 1;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  z-index: 9999;\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.22);\n}\n\n.app-shell.sidebar-collapsed .sidebar .menu-item:hover .sidebar-tooltip,\n.app-shell.sidebar-collapsed .sidebar .menu-item:focus-visible .sidebar-tooltip,\n.app-shell.sidebar-collapsed .sidebar .menu-item:focus-within .sidebar-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n.app-shell.sidebar-collapsed .sidebar .menu-item .sidebar-tooltip::before {\n  content: \"\";\n  position: absolute;\n  inset-inline-start: -4px;\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n  width: 8px;\n  height: 8px;\n  background: var(--neutral-900);\n}\n\n.sidebar {\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar-menu-area {\n  flex: 1 1 auto;\n  min-height: 0;\n  height: auto !important;\n}\n\n.sidebar-footer {\n  flex: 0 0 auto;\n  padding: 0.75rem 1rem 1rem;\n  border-inline-end: 1px solid var(--neutral-200);\n  border-block-start: 1px solid var(--neutral-200);\n}\n\n.sidebar-logout {\n  border: 0;\n  background: transparent;\n  padding: 0.625rem 0.75rem;\n  font-weight: 500;\n  font-size: 0.875rem;\n  color: var(--text-secondary-light);\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: start;\n}\n\n.sidebar-logout:hover,\n.sidebar-logout:focus-visible {\n  color: var(--primary-600);\n}\n\n.app-shell.sidebar-collapsed .sidebar .sidebar-menu-group-title {\n  display: none !important;\n}\n\n.app-shell.sidebar-collapsed .sidebar .sidebar-submenu {\n  display: none !important;\n}\n\n.app-shell.sidebar-collapsed .sidebar .dropdown > a::after {\n  display: none !important;\n}\n\n.app-shell.sidebar-collapsed .dashboard-main {\n  margin-inline-start: 5.375rem !important;\n}\n\n@media (min-width: 1400px) {\n  .app-shell.sidebar-collapsed .dashboard-main {\n    margin-inline-start: 5.375rem !important;\n  }\n}\n\n@media (min-width: 1650px) {\n  .app-shell.sidebar-collapsed .dashboard-main {\n    margin-inline-start: 5.375rem !important;\n  }\n}\n\n.sidebar-menu li a iconify-icon.menu-icon,\n.sidebar-menu li.dropdown > a iconify-icon.menu-icon,\n.sidebar-menu .sidebar-submenu li a iconify-icon.menu-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  min-width: 24px;\n  margin-inline-end: 0.5rem;\n  font-size: 1.125rem;\n  line-height: 1.2;\n}\n\n@media (min-width: 1650px) {\n  .sidebar-menu li a iconify-icon.menu-icon,\n  .sidebar-menu li.dropdown > a iconify-icon.menu-icon,\n  .sidebar-menu .sidebar-submenu li a iconify-icon.menu-icon {\n    font-size: 1.375rem;\n    margin-inline-end: 0.75rem;\n  }\n}\n\n.sidebar-menu li.dropdown > a {\n  position: relative;\n  margin: 6px 0px;\n}\n\n.sidebar-menu li.dropdown.open > a,\n.sidebar-menu li.dropdown.dropdown-open > a {\n  background-color: var(--primary-50);\n  color: var(--primary-600);\n}\n\n.sidebar-menu li.dropdown.open > a:hover,\n.sidebar-menu li.dropdown.dropdown-open > a:hover {\n  background-color: var(--primary-100);\n  color: var(--primary-700);\n}\n\n.sidebar-menu .sidebar-submenu li.active-page a,\n.sidebar-menu .sidebar-submenu li a.active-page {\n  background-color: var(--primary-600);\n  color: #fff;\n}\n\n.sidebar-menu .sidebar-submenu li.active-page a:hover,\n.sidebar-menu .sidebar-submenu li a.active-page:hover {\n  color: #fff;\n}\n\n.sidebar-menu .sidebar-submenu {\n  padding-inline-start: 1.75rem;\n}\n\n@media (min-width: 1650px) {\n  .sidebar-menu .sidebar-submenu {\n    padding-inline-start: 3rem;\n  }\n}\n\n.sidebar-menu .sidebar-submenu li a {\n  padding: 0.4375rem 0.75rem;\n}\n\n.sidebar-menu .sidebar-submenu .menu-item {\n  padding-inline-start: 0.25rem;\n}\n\n.sidebar-menu li.dropdown > a::after {\n  inset-inline-end: 0.75rem;\n}\n\n.sidebar-menu li a,\n.sidebar-menu li a:link,\n.sidebar-menu li a:visited,\n.sidebar-menu li.dropdown > a,\n.sidebar-menu .sidebar-submenu li a {\n  align-items: center;\n  min-height: 2.5rem;\n  color: var(--text-secondary-light);\n}\n\n.sidebar-menu li > a.active-page,\n.sidebar-menu li > a.active-page:visited,\n.sidebar-menu li > a.active-page:hover,\n.sidebar-menu .sidebar-submenu li.active-page a,\n.sidebar-menu .sidebar-submenu li.active-page a:visited {\n  color: #fff;\n}\n\n.sidebar-menu li a .menu-icon,\n.sidebar-menu li.dropdown > a .menu-icon,\n.sidebar-menu .sidebar-submenu li a .menu-icon,\n.sidebar-logout .menu-icon {\n  flex: 0 0 24px;\n  min-width: 24px;\n}\n\n.app-shell,\n.dashboard-main,\n.navbar-header,\n.navbar-header .row,\n.navbar-header .col-auto {\n  min-width: 0;\n}\n\n.navbar-header {\n  height: auto;\n  min-height: 4.5rem;\n  overflow: visible;\n  z-index: 1030;\n}\n\n.navbar-header-row {\n  flex-wrap: nowrap;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.navbar-header-start,\n.navbar-header-actions {\n  min-width: 0;\n  overflow: visible;\n}\n\n.navbar-action-btn {\n  flex-shrink: 0;\n}\n\n.navbar-shortcuts {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.navbar-shortcut {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-height: 2.5rem;\n  padding: 0.4rem 0.8rem;\n  border-radius: 8px;\n  color: var(--text-secondary-light);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.navbar-shortcut:hover,\n.navbar-shortcut:focus-visible,\n.navbar-shortcut.is-active {\n  color: var(--primary-600);\n  background: var(--primary-50);\n}\n\n.navbar-shortcut-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n}\n\n.navbar-shortcut-icon iconify-icon {\n  font-size: 1.05rem;\n}\n\n.navbar-wallet {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-height: 40px;\n  padding: 0.3rem 0.8rem 0.3rem 0.4rem;\n  border-radius: 999px;\n  background: var(--neutral-200);\n  color: var(--text-primary-light);\n  font-size: 0.8125rem;\n  font-weight: 700;\n  line-height: 1;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.navbar-wallet:hover,\n.navbar-wallet:focus-visible {\n  color: var(--primary-600);\n  background: var(--primary-50);\n}\n\n.navbar-wallet-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #fff;\n  color: var(--primary-600);\n}\n\n.navbar-wallet-icon iconify-icon {\n  font-size: 1rem;\n}\n\n.navbar-wallet-amount {\n  color: var(--primary-600);\n}\n\n.navbar-unread-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  transform: none;\n  min-width: 1.125rem;\n  height: 1.125rem;\n  padding: 0 0.25rem;\n  font-size: 0.625rem;\n  line-height: 1.125rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-dropdown {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.profile-dropdown-toggle.has-indicator::before {\n  display: none;\n}\n\n.dropdown-menu.profile-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  left: auto;\n  inset-inline-end: 0;\n  inset-inline-start: auto;\n  display: none;\n  width: min(20rem, calc(100vw - 1.5rem));\n  min-width: 0;\n  max-width: min(20rem, calc(100vw - 1.5rem));\n  padding: 0.75rem;\n  overflow: hidden;\n  box-sizing: border-box;\n  transform: none !important;\n  z-index: 1080;\n}\n\n.dropdown-menu.profile-dropdown-menu.show {\n  display: block;\n}\n\n.profile-dropdown-head {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.75rem 0.75rem 0.75rem 0.875rem;\n  margin-bottom: 0.75rem;\n  border-radius: 0.5rem;\n  background: var(--primary-50);\n  overflow: hidden;\n}\n\n.profile-dropdown-identity {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n  flex: 1 1 auto;\n  padding-inline-end: 0.25rem;\n}\n\n.profile-dropdown-avatar {\n  flex-shrink: 0;\n}\n\n.profile-dropdown-meta {\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.profile-dropdown-meta h6,\n.profile-dropdown-meta span {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.profile-dropdown-close,\n.profile-dropdown-close.agent-icon-btn {\n  position: static !important;\n  top: auto !important;\n  right: auto !important;\n  inset: auto !important;\n  flex: 0 0 1.75rem;\n  width: 1.75rem;\n  height: 1.75rem;\n  margin: 0;\n  align-self: flex-start;\n  background: #fff;\n  color: var(--primary-600);\n  box-shadow: none;\n}\n\n.profile-dropdown-close iconify-icon {\n  font-size: 0.875rem;\n  line-height: 1;\n}\n\n.profile-dropdown-list {\n  padding: 0 0.25rem 0.25rem;\n  margin: 0;\n}\n\n.profile-dropdown-list .dropdown-item {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.profile-dropdown-list .dropdown-item iconify-icon {\n  flex-shrink: 0;\n}\n\n.booking-page .container-fluid {\n  width: 100%;\n}\n\n.booking-page .row {\n  margin-left: -0.75rem;\n  margin-right: -0.75rem;\n}\n\n.booking-page .col-lg-8 {\n  flex: 0 0 72%;\n  max-width: 72%;\n}\n\n.booking-page .col-lg-4 {\n  flex: 0 0 28%;\n  max-width: 28%;\n}\n\n.booking-page .form-control,\n.booking-page .form-select,\n.booking-page textarea {\n  width: 100%;\n}\n\n.booking-page .card-body .row.g-3 {\n  row-gap: 1rem;\n}\n\n.booking-page .card-body .row.g-3 > [class*=\"col-\"] {\n  display: flex;\n  flex-direction: column;\n}\n\n.booking-page .card-body .row.g-3 > [class*=\"col-\"] > .form-label,\n.booking-page .card-body .row.g-3 > [class*=\"col-\"] > .position-relative,\n.booking-page .card-body .row.g-3 > [class*=\"col-\"] > input,\n.booking-page .card-body .row.g-3 > [class*=\"col-\"] > select,\n.booking-page .card-body .row.g-3 > [class*=\"col-\"] > textarea {\n  width: 100%;\n}\n\n.booking-page .card.border .card-body.d-grid {\n  gap: 10px !important;\n}\n\n.booking-page .card.border .card-body.d-grid .btn {\n  width: 100%;\n}\n\n@media (max-width: 767.98px) {\n  .booking-page .container-fluid {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n/* Global Agent Portal UI consistency */\n.dashboard-main-body,\n.auth-right {\n  font-family: Poppins, sans-serif;\n}\n\n.dashboard-main-body .container-fluid {\n  width: 100%;\n  min-width: 0;\n}\n\n.dashboard-main-body h3,\n.auth-right h4 {\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n}\n\n.dashboard-main-body h5,\n.dashboard-main-body h6 {\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.dashboard-main-body .form-label,\n.auth-right .form-label {\n  font-weight: 500;\n  font-size: 0.875rem;\n  margin-bottom: 0.375rem;\n}\n\n.dashboard-main-body .form-control,\n.dashboard-main-body .form-select,\n.auth-right .form-control,\n.auth-right .form-select {\n  border-radius: 0.5rem;\n  border-color: #e6e6e6;\n  min-height: 2.813rem;\n}\n\n.dashboard-main-body .form-control:focus,\n.dashboard-main-body .form-select:focus,\n.auth-right .form-control:focus,\n.auth-right .form-select:focus {\n  border-color: #c6272a;\n  box-shadow: 0 0 0 0.2rem rgba(198, 39, 42, 0.12);\n}\n\n.dashboard-main-body .form-control-sm,\n.dashboard-main-body .form-select-sm {\n  min-height: 2.25rem;\n}\n\n.dashboard-main-body .btn,\n.auth-right .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.dashboard-main-body .btn iconify-icon,\n.auth-right .btn iconify-icon {\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.dashboard-main-body .card {\n  border-radius: 12px;\n  background: #fff;\n}\n\n.dashboard-main-body .card.border-0.shadow-sm {\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06) !important;\n}\n\n.dashboard-main-body .table,\n.agent-table {\n  --bs-table-bg: #fff;\n  --bs-table-hover-bg: var(--neutral-50, #f8fafc);\n}\n\n.agent-table-wrap {\n  width: 100%;\n  -webkit-overflow-scrolling: touch;\n}\n\n.dashboard-main-body .bordered-table,\n.agent-table.bordered-table {\n  width: 100%;\n  background: #fff;\n}\n\n.dashboard-main-body .bordered-table tbody tr:hover td,\n.agent-table.bordered-table tbody tr:hover td {\n  background-color: var(--neutral-50, #f8fafc);\n}\n\n.dashboard-main-body .table thead th,\n.agent-table thead th,\n.dashboard-main-body .bordered-table thead tr th {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n  color: var(--text-primary-light, #111827) !important;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.dashboard-main-body .table td,\n.agent-table td {\n  vertical-align: middle;\n  overflow-wrap: anywhere;\n}\n\n.dashboard-main-body .table tbody tr,\n.agent-table tbody tr {\n  height: 3.5rem;\n}\n\n.agent-kyc-actions {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  min-width: 8.75rem;\n}\n\n.agent-kyc-actions__link {\n  min-width: 4.25rem;\n  text-align: left;\n  line-height: 1.2;\n}\n\n.agent-kyc-actions__link--spacer {\n  visibility: hidden;\n  pointer-events: none;\n  display: inline-block;\n}\n\n.agent-kyc-block__title {\n  margin: 0 0 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #ececec;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary-light, #111827);\n}\n\n.agent-kyc-detail__label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-secondary-light, #6b7280);\n  margin-bottom: 0.25rem;\n}\n\n.agent-kyc-detail__value {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary-light, #111827);\n  word-break: break-word;\n}\n\n.agent-kyc-note {\n  padding: 12px 14px;\n  background: #f8fafc;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--text-secondary-light, #6b7280);\n}\n\n.dashboard-main-body .table td .text-end,\n.dashboard-main-body .table th.text-end,\n.dashboard-main-body .table td.text-end,\n.agent-table th.text-end,\n.agent-table td.text-end {\n  white-space: nowrap;\n}\n\n.dashboard-main-body .table a:not(.btn):not(.agent-icon-btn),\n.agent-table a:not(.btn):not(.agent-icon-btn),\n.agent-table-link {\n  color: var(--primary-600);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.dashboard-main-body .table a:not(.btn):not(.agent-icon-btn),\n.agent-table a:not(.btn):not(.agent-icon-btn) {\n  white-space: nowrap;\n}\n\n.dashboard-main-body .table a:not(.btn):not(.agent-icon-btn):hover,\n.dashboard-main-body .table a:not(.btn):not(.agent-icon-btn):focus-visible,\n.agent-table a:not(.btn):not(.agent-icon-btn):hover,\n.agent-table a:not(.btn):not(.agent-icon-btn):focus-visible,\n.agent-table-link:hover,\n.agent-table-link:focus-visible {\n  color: var(--primary-700);\n  text-decoration: underline;\n}\n\n.dashboard-main-body input[type=\"file\"].form-control {\n  padding-top: 0.45rem;\n  padding-bottom: 0.45rem;\n}\n\n.page-toolbar {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  min-width: 0;\n  flex: 0 0 auto;\n}\n\n.page-toolbar .btn {\n  flex: 0 0 auto;\n  min-height: 2.813rem;\n}\n\n.agent-page-header__meta {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  min-width: 0;\n  flex: 0 1 auto;\n}\n\n.agent-back-btn {\n  flex: 0 0 auto;\n}\n\n.agent-back-btn:focus-visible {\n  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.35);\n}\n\n.agent-breadcrumb {\n  min-width: 0;\n  font-size: 0.875rem;\n  line-height: 1.4;\n}\n\n.agent-breadcrumb > li {\n  white-space: nowrap;\n}\n\n.agent-breadcrumb a {\n  text-decoration: none;\n  color: var(--text-secondary-light);\n}\n\n.agent-breadcrumb a:hover {\n  color: var(--primary-600);\n}\n\n.agent-breadcrumb__current {\n  color: var(--text-primary-light, #111827);\n}\n\n.agent-breadcrumb iconify-icon.icon {\n  font-size: 1.125rem;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n}\n\n.agent-settings-tabs,\n.agent-tabs {\n  max-width: 100%;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n}\n\n.agent-tabs .nav-item,\n.agent-settings-tabs .nav-item {\n  flex: 0 0 auto;\n}\n\n.agent-tabs .nav-link,\n.bordered-tab .nav-link {\n  white-space: nowrap;\n}\n\n.agent-tabs .nav-link:hover:not(.active),\n.bordered-tab .nav-link:hover:not(.active) {\n  color: var(--primary-600);\n}\n\n.agent-tabs::-webkit-scrollbar,\n.agent-settings-tabs::-webkit-scrollbar,\n.agent-booking-tabs::-webkit-scrollbar,\n.agent-package-tabs::-webkit-scrollbar {\n  height: 4px;\n}\n\n.agent-tabs::-webkit-scrollbar-thumb,\n.agent-settings-tabs::-webkit-scrollbar-thumb,\n.agent-booking-tabs::-webkit-scrollbar-thumb,\n.agent-package-tabs::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 999px;\n}\n\n.agent-package-tabs::-webkit-scrollbar {\n  height: 4px;\n}\n\n.agent-package-detail {\n  max-width: 1480px;\n  margin-inline: auto;\n}\n\n.agent-package-header {\n  overflow: hidden;\n}\n\n.agent-package-header__grid {\n  display: grid;\n  grid-template-columns: minmax(240px, 360px) minmax(0, 1fr);\n}\n\n.agent-package-header__grid .catalog-image-wrap {\n  height: 100%;\n  min-height: 240px;\n}\n\n.agent-package-header__facts,\n.agent-package-facts,\n.agent-package-occupancy {\n  display: grid;\n  gap: 0.85rem 1rem;\n}\n\n.agent-package-header__facts,\n.agent-package-facts {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.agent-package-facts--pricing {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  max-width: 28rem;\n}\n\n.agent-package-occupancy {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.agent-package-occupancy-item {\n  border: 1px solid var(--neutral-200, #e5e7eb);\n  border-radius: 0.75rem;\n  padding: 0.9rem 1rem;\n  background: #fff;\n}\n\n.agent-package-occupancy-heading {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  margin-bottom: 0.7rem;\n}\n\n.agent-package-occupancy-icon {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.5rem;\n  background: #f8e9eb;\n  color: var(--primary, #c32032);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.05rem;\n  flex-shrink: 0;\n}\n\n.agent-package-occupancy-prices {\n  display: grid;\n  gap: 0.35rem 0.75rem;\n}\n\n.agent-package-occupancy-price {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.agent-package-occupancy-price span {\n  font-size: 0.72rem;\n  font-weight: 500;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #6b7280;\n}\n\n.agent-package-occupancy-price strong {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.agent-package-occupancy-price--rsp strong {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.agent-package-fact-label {\n  font-size: 0.72rem;\n  font-weight: 500;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #6b7280;\n  margin-bottom: 0.2rem;\n}\n\n.agent-package-panel .card-header.agent-package-tabbar {\n  background: #fff;\n  border-bottom: 1px solid var(--neutral-200, #e5e7eb);\n  padding: 0 8px;\n}\n\n.agent-package-tabs {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0 !important;\n  border-top: 0;\n  display: flex;\n}\n\n.agent-package-tabs .nav-link {\n  padding: 16px 24px;\n}\n\n.agent-package-section-title {\n  font-size: 1.05rem;\n  font-weight: 600;\n  line-height: 1.3;\n  margin-bottom: 0.85rem;\n}\n\n.agent-package-empty {\n  padding: 1.75rem 1rem;\n  text-align: center;\n  color: #6b7280;\n  font-size: 0.9rem;\n  border: 1px dashed #e5e7eb;\n  border-radius: 0.75rem;\n  background: #fafafa;\n}\n\n.agent-package-list {\n  margin: 0;\n  padding-left: 1.1rem;\n}\n\n.agent-package-list li + li {\n  margin-top: 0.35rem;\n}\n\n.agent-package-feature-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.7rem;\n}\n\n.agent-package-feature-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  line-height: 1.45;\n}\n\n.agent-package-feature-icon {\n  flex: 0 0 auto;\n  font-size: 1.15rem;\n  margin-top: 0.05rem;\n  color: var(--primary-600);\n}\n\n.agent-package-city-title {\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--primary-600);\n  margin: 0 0 0.75rem;\n}\n\n.agent-package-hotels section + section {\n  margin-top: 1.35rem;\n}\n\n.agent-package-hotel-list,\n.agent-package-flight-list {\n  display: grid;\n  gap: 0.85rem;\n}\n\n.agent-package-flight-leg {\n  display: grid;\n  gap: 0.35rem;\n  padding: 0.85rem 0;\n  border-bottom: 1px solid #eef0f3;\n}\n\n.agent-package-hotel {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  padding: 0.85rem 0;\n  border-bottom: 1px solid #eef0f3;\n}\n\n.agent-package-hotel .catalog-image-wrap {\n  width: 160px;\n  flex: 0 0 160px;\n  height: 120px;\n  border-radius: 0.75rem;\n}\n\n.agent-package-hotel:last-child,\n.agent-package-flight-leg:last-child {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.agent-package-hotel:first-child,\n.agent-package-flight-leg:first-child {\n  padding-top: 0;\n}\n\n.agent-package-hotel__meta,\n.agent-package-flight-leg__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.85rem;\n  margin-top: 0.35rem;\n  color: #6b7280;\n  font-size: 0.8125rem;\n}\n\n.agent-package-flight-leg__title {\n  font-weight: 600;\n}\n\n.agent-package-itinerary {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.agent-package-itinerary-item {\n  display: grid;\n  grid-template-columns: 12px minmax(0, 1fr);\n  gap: 0.2rem 0.85rem;\n  position: relative;\n  padding-bottom: 1.15rem;\n}\n\n.agent-package-itinerary-item:last-child {\n  padding-bottom: 0;\n}\n\n.agent-package-itinerary-item:not(:last-child)::before {\n  content: \"\";\n  position: absolute;\n  left: 5px;\n  top: 14px;\n  bottom: 0;\n  width: 2px;\n  background: var(--primary-100);\n}\n\n.agent-package-itinerary-dot {\n  width: 10px;\n  height: 10px;\n  margin-top: 0.35rem;\n  border-radius: 50%;\n  background: var(--primary-600);\n  box-shadow: 0 0 0 3px var(--primary-50);\n  z-index: 1;\n}\n\n.agent-package-itinerary-day {\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--primary-700);\n  margin-bottom: 0.15rem;\n}\n\n.agent-package-itinerary-city {\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #6b7280;\n  margin-bottom: 0.15rem;\n}\n\n.agent-package-gallery {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.85rem;\n}\n\n.agent-package-gallery .catalog-image-wrap {\n  border-radius: 0.75rem;\n}\n\n.agent-booking-detail {\n  max-width: 1480px;\n  margin-inline: auto;\n}\n\n.agent-booking-kicker {\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #6b7280;\n  margin-bottom: 0.2rem;\n}\n\n.agent-booking-ref {\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 1.25;\n  margin: 0;\n  word-break: break-word;\n}\n\n.agent-booking-section-title {\n  font-size: 1.05rem;\n  font-weight: 600;\n  line-height: 1.3;\n  margin-bottom: 0.75rem;\n}\n\n.agent-booking-section-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.agent-passenger-form {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.85rem 1rem;\n  align-items: start;\n  margin-bottom: 1rem;\n}\n\n.agent-passenger-form__field {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.agent-passenger-form .form-control,\n.agent-passenger-form .form-select {\n  width: 100%;\n  min-width: 0;\n}\n\n.agent-passenger-form__span-2 {\n  grid-column: span 2;\n}\n\n.agent-passenger-form__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n}\n\n@media (max-width: 1199.98px) {\n  .agent-passenger-form {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 575.98px) {\n  .agent-passenger-form {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .agent-passenger-form__span-2 {\n    grid-column: auto;\n  }\n}\n\n.agent-booking-field-label {\n  font-size: 0.72rem;\n  font-weight: 500;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #6b7280;\n  margin-bottom: 0.2rem;\n}\n\n.agent-booking-field-value {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #111827;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.agent-booking-field-value .agent-status-badge {\n  font-weight: 500;\n}\n\n.agent-booking-field-meta {\n  font-size: 0.8125rem;\n  color: #6b7280;\n  margin-top: 0.25rem;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.agent-booking-header-card .card-body {\n  padding: 1rem 1.25rem 1.1rem;\n}\n\n.dashboard-main-body .agent-booking-header-card.card.border-0.shadow-sm .card-body {\n  padding: 1rem 1.25rem 1.1rem;\n}\n\n.agent-booking-header-top {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n  margin-bottom: 0.9rem;\n  padding-bottom: 0.85rem;\n  border-bottom: 1px solid #eef0f3;\n}\n\n.agent-booking-header-meta {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.75rem 1rem;\n  align-items: start;\n}\n\n@media (min-width: 1600px) {\n  .agent-booking-header-meta {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n}\n\n.agent-booking-panel-card .card-header.agent-booking-tabbar {\n  background: #fff;\n  border-bottom: 1px solid var(--neutral-200, #e5e7eb);\n  padding: 0 8px;\n}\n\n.agent-booking-panel-card .card-body {\n  padding: 1.1rem 1.25rem 1.25rem;\n}\n\n.dashboard-main-body .agent-booking-panel-card.card.border-0.shadow-sm .card-body {\n  padding: 1.1rem 1.25rem 1.25rem;\n}\n\n.agent-booking-tabs {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0 !important;\n  border-top: 0;\n  display: flex;\n}\n\n.agent-booking-tabs .nav-link {\n  padding: 16px 24px;\n}\n\n.agent-booking-summary,\n.agent-booking-readiness,\n.agent-booking-payment-summary {\n  display: grid;\n  gap: 0.75rem;\n  margin-bottom: 1.35rem;\n}\n\n.agent-booking-summary {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  padding: 0.85rem 1rem;\n  border: 1px solid #eef0f3;\n  border-radius: 0.75rem;\n  background: #fafafa;\n}\n\n.agent-booking-summary--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.agent-booking-header-meta > *,\n.agent-booking-summary > *,\n.agent-booking-readiness > *,\n.agent-booking-payment-summary > * {\n  min-width: 0;\n}\n\n.agent-booking-readiness {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.agent-booking-payment-summary {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.agent-booking-tile {\n  display: flex;\n  flex-direction: column;\n  padding: 0.85rem 0.95rem;\n  border: 1px solid #eef0f3;\n  border-radius: 0.75rem;\n  background: #fff;\n}\n\n.agent-booking-tile .agent-booking-field-value {\n  margin-top: 0.1rem;\n}\n\n.agent-booking-empty {\n  padding: 1.75rem 1rem;\n  text-align: center;\n  color: #6b7280;\n  font-size: 0.9rem;\n  border: 1px dashed #e5e7eb;\n  border-radius: 0.75rem;\n  background: #fafafa;\n}\n\n.agent-booking-hotels {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n  align-items: stretch;\n}\n\n.agent-booking-hotel-card {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  min-width: 0;\n  height: 100%;\n  overflow: hidden;\n  border: 1px solid #eef0f3;\n  border-radius: 1rem;\n  background: #fff;\n}\n\n.agent-hotel-photo {\n  width: 200px;\n  height: 200px;\n  flex: 0 0 200px;\n  background: #f3f4f6;\n}\n\n.agent-hotel-photo .catalog-image-wrap {\n  width: 200px !important;\n  height: 200px !important;\n}\n\n.agent-booking-hotel-body {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 1rem 1rem 1.1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.agent-booking-hotel-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 0.9rem;\n  min-height: 5.5rem;\n}\n\n.agent-booking-hotel-address {\n  margin-top: 0.25rem;\n  color: #6b7280;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  min-height: 2.8em;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.agent-booking-hotel-address--empty {\n  visibility: hidden;\n}\n\n.agent-booking-hotel-section + .agent-booking-hotel-section {\n  margin-top: 0.85rem;\n  padding-top: 0.85rem;\n  border-top: 1px solid #f1f3f5;\n}\n\n.agent-booking-hotel-section-title {\n  margin-bottom: 0.5rem;\n  color: #6b7280;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.agent-booking-hotel-meta {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.55rem 0.75rem;\n}\n\n.agent-booking-inline-actions {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n\n.agent-booking-actions {\n  min-width: 13.5rem;\n}\n\n.d-footer .row {\n  --bs-gutter-y: 0.5rem;\n}\n\n.dashboard-main-body .table .btn-sm {\n  min-height: 2rem;\n}\n\n.agent-status-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  max-width: 100%;\n  line-height: 1.4;\n}\n\n.agent-person-cell {\n  gap: 12px;\n  min-width: 0;\n}\n\n.agent-table-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: var(--primary-50);\n  color: var(--primary-600);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.dashboard-main {\n  overflow: visible;\n}\n\n.dashboard-main-body {\n  overflow-x: hidden;\n  max-width: 100%;\n}\n\n.agent-select {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.page-search {\n  width: 16rem;\n  max-width: 320px;\n  flex: 0 1 16rem;\n}\n\n.page-toolbar .page-search,\n.page-toolbar .agent-select {\n  width: 16rem;\n  max-width: 16rem;\n}\n\n.agent-select.page-search {\n  max-width: 360px;\n}\n\n.agent-select .agent-select__control {\n  min-height: 2.813rem;\n}\n\n.agent-select-menu-footer {\n  border-top: 1px solid #eef0f3;\n  padding: 0.35rem;\n  background: #fff;\n}\n\n.agent-select-menu-action {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  width: 100%;\n  border: 0;\n  background: transparent;\n  color: #c6272a;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n  padding: 0.55rem 0.75rem;\n  border-radius: 0.4rem;\n  text-align: left;\n}\n\n.agent-select-menu-action:hover,\n.agent-select-menu-action:focus-visible {\n  background: rgba(198, 39, 42, 0.08);\n  outline: none;\n}\n\n.agent-flash {\n  margin-bottom: 1rem;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.agent-alert-host {\n  position: fixed;\n  inset: 0;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: auto;\n  height: 5.5rem;\n  z-index: 1080;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 1rem;\n  pointer-events: none;\n}\n\n.agent-alert-host .agent-alert-toast,\n.agent-alert-host .agent-flash {\n  pointer-events: auto;\n  max-width: 36rem;\n  width: 100%;\n  margin-bottom: 0;\n  justify-content: space-between;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);\n  animation: agent-flash-center 0.65s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes agent-flash-center {\n  0% {\n    opacity: 0;\n    transform: translateY(-28px) scale(0.86);\n  }\n  55% {\n    opacity: 1;\n    transform: translateY(6px) scale(1.04);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (max-width: 575.98px) {\n  .agent-alert-host {\n    height: 5rem;\n    padding: 0 0.75rem;\n  }\n}\n\n.agent-flash-close,\n.agent-flash .agent-flash-close {\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: transparent;\n  color: inherit;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.agent-flash-close:hover,\n.agent-flash-close:focus-visible,\n.agent-flash .agent-flash-close:hover,\n.agent-flash .agent-flash-close:focus-visible {\n  background: rgba(15, 23, 42, 0.06);\n  color: inherit;\n}\n\n.agent-page-loader .spinner-border {\n  width: 2.25rem;\n  height: 2.25rem;\n}\n\n.dashboard-main-body .card.border-0.shadow-sm .card-body {\n  padding: 1.25rem;\n}\n\n.dashboard-main-body .package-card.card.border-0.shadow-sm .card-body {\n  padding: 0.9rem 0.95rem 1rem;\n}\n\n.dashboard-main-body .list-group-item-action {\n  text-align: left;\n}\n\n.border-gradient-tab .nav-link::before {\n  border-top-color: var(--primary-600);\n  background: linear-gradient(180deg, rgba(198, 39, 42, 0.12) 0%, rgba(198, 39, 42, 0.03) 100%);\n}\n\n.agent-icon-btn {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: var(--primary-light);\n  color: var(--primary-600);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n.agent-icon-btn:hover,\n.agent-icon-btn:focus-visible {\n  color: var(--primary-700);\n  background: var(--primary-100);\n}\n\n.agent-icon-btn:disabled {\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n.agent-icon-btn iconify-icon {\n  font-size: 1rem;\n}\n\n.agent-itinerary-notes {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-width: 0;\n  max-width: 220px;\n}\n\n.agent-itinerary-notes-preview {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #4b5563;\n  font-size: 0.875rem;\n}\n\n.agent-modal-root {\n  position: fixed;\n  inset: 0;\n  z-index: 2200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.agent-modal-backdrop {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background: rgba(15, 23, 42, 0.55);\n}\n\n.agent-modal-root .modal-dialog {\n  position: relative;\n  z-index: 2;\n  margin: 0;\n  width: calc(100% - 2rem);\n  max-width: 520px;\n}\n\n.agent-modal-root .modal-content {\n  position: relative;\n  background: #fff;\n  border: 0;\n  border-radius: 0.85rem;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.28);\n  overflow: hidden;\n}\n\n.agent-modal-root .modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 1.15rem 3rem 1rem 1.5rem;\n  border-bottom: 1px solid #eef0f3;\n}\n\n.agent-modal-root .modal-title {\n  margin: 0;\n  padding: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  line-height: 1.4;\n  color: #111827;\n}\n\n.agent-modal-root .modal-header .btn-close {\n  position: absolute;\n  top: 0.85rem;\n  inset-inline-end: 0.85rem;\n  margin: 0;\n  padding: 0.5rem;\n  width: 2rem;\n  height: 2rem;\n  flex-shrink: 0;\n}\n\n.agent-modal-root .modal-body,\n.agent-modal-body {\n  padding: 1.25rem 1.5rem;\n}\n\n.agent-modal-root .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 1rem 1.5rem 1.25rem;\n  border-top: 1px solid #eef0f3;\n}\n\n.agent-notes-modal .modal-content,\n.agent-notes-modal .modal-body,\n.agent-modal-body {\n  min-width: 0;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.agent-upload-progress-label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.45rem;\n  font-size: 0.8125rem;\n  color: #64748b;\n}\n\n.agent-upload-progress .progress {\n  height: 0.7rem;\n  border-radius: 999px;\n  background: #f1f5f9;\n  overflow: hidden;\n}\n\n.agent-upload-progress .progress-bar {\n  background: var(--primary-600);\n}\n\n.agent-modal-root.agent-document-preview-modal .modal-dialog {\n  width: min(920px, calc(100vw - 2rem));\n  max-width: min(920px, calc(100vw - 2rem));\n}\n\n.agent-document-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.85rem;\n  min-width: 0;\n}\n\n.agent-document-preview img,\n.agent-document-preview iframe {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  border: 0;\n  border-radius: 0.5rem;\n  background: #f8fafc;\n}\n\n.agent-document-preview img {\n  max-height: min(72vh, 640px);\n  object-fit: contain;\n}\n\n.agent-document-preview iframe {\n  height: min(72vh, 640px);\n}\n\n.agent-document-preview-nav {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: #64748b;\n  font-size: 0.8125rem;\n}\n\n.agent-itinerary-notes-html {\n  min-width: 0;\n  max-width: 100%;\n  overflow-x: hidden;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  white-space: normal;\n  line-height: 1.75;\n  color: #374151;\n  font-size: 0.95rem;\n}\n\n.agent-itinerary-notes-heading {\n  margin: 0 0 1rem;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.45;\n}\n\n.agent-itinerary-notes-html p {\n  margin: 0 0 1rem;\n  max-width: 100%;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  white-space: normal;\n}\n\n.agent-itinerary-notes-html p:last-child {\n  margin-bottom: 0;\n}\n\n.agent-profile-cover {\n  height: 140px;\n  width: 100%;\n  object-fit: cover;\n  display: block;\n  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-800) 100%);\n}\n\n.agent-profile-avatar {\n  width: 140px;\n  height: 140px;\n  border: 4px solid #fff;\n  border-radius: 50%;\n  background: var(--primary-50);\n  color: var(--primary-600);\n  font-size: 2rem;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -70px;\n}\n\n.agent-profile-info-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  margin-bottom: 12px;\n}\n\n.agent-profile-info-list li:last-child {\n  margin-bottom: 0;\n}\n\n.agent-profile-info-label {\n  flex: 0 0 38%;\n  max-width: 38%;\n  font-weight: 600;\n  color: var(--text-primary-light, #111827);\n}\n\n.agent-profile-info-value {\n  flex: 1 1 auto;\n  min-width: 0;\n  color: var(--text-secondary-light, #6b7280);\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.agent-profile-section {\n  margin-bottom: 1.5rem;\n}\n\n.agent-profile-section:last-of-type {\n  margin-bottom: 1.75rem;\n}\n\n.agent-profile-section__title {\n  margin: 0 0 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #ececec;\n  color: var(--text-primary-light, #111827);\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.agent-password-toggle {\n  position: absolute;\n  inset-inline-end: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  border: 0;\n  background: transparent;\n  color: var(--text-secondary-light, #6b7280);\n  padding: 0;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.profile-dropdown-close.agent-icon-btn {\n  width: 1.75rem;\n  height: 1.75rem;\n  background: #fff;\n}\n\n.agent-notification-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.875rem;\n  padding: 1rem;\n  border: 1px solid #eef0f3;\n  border-radius: 0.75rem;\n  background: #fff;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n  text-align: left;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.agent-notification-item.is-unread {\n  background: #fdecec;\n  border-color: #f0a8aa;\n}\n\n.agent-notification-item:hover,\n.agent-notification-item:focus-visible {\n  border-color: #f0a8aa;\n}\n\n.min-w-0 {\n  min-width: 0;\n}\n\n.auth,\n.auth-left,\n.auth-right,\n.auth-form-card {\n  min-width: 0;\n}\n\n.auth-right {\n  overflow-x: hidden;\n}\n\n.form-check.style-check .form-check-label {\n  min-width: 0;\n  white-space: normal;\n}\n\n.auth-left {\n  overflow: hidden;\n}\n\n.auth-hero-image {\n  max-width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n.auth-form-card {\n  width: 100%;\n}\n\n.auth-password-field {\n  position: relative;\n}\n\n.auth-password-input {\n  padding-inline-end: 2.75rem;\n}\n\n.auth-password-toggle {\n  position: absolute;\n  top: 50%;\n  inset-inline-end: 1rem;\n  transform: translateY(-50%);\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-secondary-light, #6b7280);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.auth-form-meta {\n  min-width: 0;\n}\n\n.auth-wizard-steps {\n  max-width: 100%;\n}\n\n.form-wizard,\n.form-wizard-header {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.form-wizard .form-group .btn {\n  white-space: nowrap;\n}\n\n.sidebar-close-btn {\n  z-index: 4;\n}\n\n@media (max-width: 1399.98px) {\n  .navbar-search-field {\n    width: min(16rem, 100%);\n  }\n\n  .navbar-shortcut-label {\n    display: none;\n  }\n\n  .navbar-shortcut {\n    padding: 0.4rem 0.55rem;\n  }\n\n  .agent-booking-readiness {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .agent-booking-payment-summary {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .navbar-search-field {\n    width: min(12rem, 100%);\n  }\n\n  .dropdown-menu.profile-dropdown-menu {\n    width: min(18.5rem, calc(100vw - 1.25rem));\n    max-width: min(18.5rem, calc(100vw - 1.25rem));\n  }\n\n  .agent-booking-hotels {\n    grid-template-columns: 1fr;\n  }\n\n  .agent-package-header__facts,\n  .agent-package-facts,\n  .agent-package-occupancy {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .agent-package-gallery {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .agent-booking-summary,\n  .agent-booking-summary--3 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 991.98px) {\n  .auth-right {\n    width: 100%;\n    padding: 2rem 1.25rem;\n  }\n\n  .auth-form-card {\n    max-width: 100%;\n  }\n\n  .booking-page .col-lg-8,\n  .booking-page .col-lg-4 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .agent-booking-readiness,\n  .agent-booking-payment-summary {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .agent-booking-hotel-card {\n    flex-direction: column;\n  }\n\n  .agent-hotel-photo,\n  .agent-hotel-photo .catalog-image-wrap {\n    width: 200px !important;\n    height: 200px !important;\n    flex-basis: 200px;\n    margin: 0.85rem auto 0;\n    border-radius: 0.75rem;\n    overflow: hidden;\n  }\n\n  .agent-package-header__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .agent-package-header__grid .catalog-image-wrap {\n    min-height: 220px;\n    max-height: 240px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .dashboard-main-body .container-fluid {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .navbar-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .navbar-header-actions {\n    gap: 0.5rem;\n  }\n\n  .page-search {\n    max-width: 100%;\n    width: 100%;\n    flex: 1 1 100%;\n  }\n\n  .dashboard-main-body .d-flex.flex-wrap.justify-content-between > .page-search,\n  .dashboard-main-body .d-flex.flex-wrap.justify-content-between > .agent-select {\n    max-width: 100%;\n  }\n\n  .dashboard-main-body .d-flex.flex-wrap.align-items-center.gap-2 > .page-search,\n  .page-toolbar .page-search,\n  .page-toolbar .agent-select {\n    max-width: 100%;\n    flex: 1 1 100%;\n  }\n\n  .page-toolbar {\n    width: 100%;\n    flex-wrap: wrap;\n    justify-content: stretch;\n  }\n\n  .agent-page-header__meta {\n    width: 100%;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n\n  .package-catalog-head .agent-page-header__meta:has(.page-head-actions) {\n    justify-content: flex-end;\n  }\n\n  .auth-right {\n    padding: 1.5rem 1rem;\n  }\n\n  .auth-form-meta {\n    flex-direction: column;\n  }\n\n  .form-wizard .form-group .btn {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .dropdown-menu.profile-dropdown-menu {\n    width: min(17.5rem, calc(100vw - 1rem));\n    min-width: 0;\n    max-width: calc(100vw - 1rem);\n  }\n\n  .agent-settings-tabs,\n  .agent-tabs,\n  .agent-booking-tabs,\n  .agent-package-tabs {\n    width: 100%;\n  }\n\n  .agent-settings-tabs .nav-link,\n  .agent-tabs .nav-link,\n  .agent-booking-tabs .nav-link,\n  .agent-package-tabs .nav-link {\n    padding: 12px 16px;\n  }\n\n  .agent-package-header__facts,\n  .agent-package-facts,\n  .agent-package-occupancy,\n  .agent-package-facts--pricing {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .agent-package-gallery {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .agent-package-hotel {\n    flex-direction: column;\n  }\n\n  .agent-package-hotel .catalog-image-wrap {\n    width: 100%;\n    flex-basis: auto;\n    height: 180px;\n  }\n\n  .agent-profile-avatar {\n    width: 112px;\n    height: 112px;\n    font-size: 1.5rem;\n    margin-top: -56px;\n  }\n\n  .agent-profile-info-label,\n  .agent-profile-info-value {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n\n  .agent-booking-header-meta,\n  .agent-booking-summary,\n  .agent-booking-summary--3,\n  .agent-booking-readiness,\n  .agent-booking-payment-summary,\n  .agent-booking-hotel-meta {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .agent-booking-ref {\n    font-size: 1.25rem;\n  }\n\n  .agent-booking-inline-actions {\n    justify-content: flex-start;\n  }\n\n  .agent-breadcrumb {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .navbar-action-btn,\n  .profile-dropdown-toggle {\n    width: 2.25rem;\n    height: 2.25rem;\n  }\n\n  .form-wizard .form-group {\n    justify-content: stretch !important;\n  }\n\n  .form-wizard .form-group .btn {\n    width: 100%;\n  }\n\n  .dashboard-main-body .btn {\n    white-space: normal;\n  }\n\n  .agent-hotel-photo,\n  .agent-hotel-photo .catalog-image-wrap {\n    width: 200px !important;\n    height: 200px !important;\n  }\n\n  .agent-booking-actions {\n    min-width: 11rem;\n  }\n\n  .agent-booking-header-meta,\n  .agent-booking-summary,\n  .agent-booking-summary--3,\n  .agent-booking-readiness,\n  .agent-booking-payment-summary {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .agent-booking-hotel-meta {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .page-toolbar .btn {\n    width: auto;\n  }\n\n  .agent-page-header__meta {\n    justify-content: flex-start;\n  }\n\n  .agent-breadcrumb {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 479.98px) {\n  .agent-booking-header-meta,\n  .agent-booking-summary,\n  .agent-booking-summary--3,\n  .agent-booking-readiness,\n  .agent-booking-payment-summary,\n  .agent-booking-hotel-meta {\n    grid-template-columns: 1fr;\n  }\n\n  .agent-booking-inline-actions {\n    width: 100%;\n  }\n\n  .agent-booking-inline-actions .btn {\n    flex: 1 1 auto;\n  }\n}\n\n.agent-voucher-page {\n  max-width: 980px;\n  margin-inline: auto;\n}\n\n.agent-voucher-sheet {\n  background: #fff;\n  color: #111827;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.06);\n  overflow: hidden;\n}\n\n.agent-voucher-letterhead {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem 1.5rem;\n  padding: 1.35rem 1.5rem 1.2rem;\n  border-bottom: 3px solid var(--brand, #c6272a);\n  background: #fff;\n}\n\n.agent-voucher-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  min-width: 0;\n}\n\n.agent-voucher-logo {\n  width: auto;\n  height: 48px;\n  max-width: 168px;\n  object-fit: contain;\n}\n\n.agent-voucher-brand-name {\n  font-size: 1.15rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #111827;\n}\n\n.agent-voucher-brand-tag {\n  font-size: 0.78rem;\n  color: #6b7280;\n  margin-top: 0.15rem;\n}\n\n.agent-voucher-docmark {\n  text-align: right;\n  min-width: 12rem;\n}\n\n.agent-voucher-docmark-title {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--brand, #c6272a);\n}\n\n.agent-voucher-docmark-ref {\n  font-size: 1.2rem;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #111827;\n  margin-top: 0.15rem;\n}\n\n.agent-voucher-docmark-meta {\n  font-size: 0.8rem;\n  color: #6b7280;\n  margin-top: 0.15rem;\n}\n\n.agent-voucher-meta {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.85rem 1rem;\n  padding: 1.15rem 1.5rem;\n  background: #fafafa;\n  border-bottom: 1px solid #eee;\n}\n\n.agent-voucher-meta--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  background: transparent;\n  border-bottom: 0;\n  padding: 0;\n}\n\n.agent-voucher-field {\n  min-width: 0;\n}\n\n.agent-voucher-label {\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #6b7280;\n  margin-bottom: 0.2rem;\n}\n\n.agent-voucher-value {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #111827;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.agent-voucher-section {\n  padding: 1.1rem 1.5rem 0.25rem;\n}\n\n.agent-voucher-section-title {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--brand, #c6272a);\n  margin: 0 0 0.75rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.agent-voucher-flights {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.85rem;\n}\n\n.agent-voucher-flights--split {\n  grid-template-columns: 1fr 1fr;\n}\n\n.agent-voucher-flight,\n.agent-voucher-hotel {\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  padding: 0.9rem 1rem;\n  background: #fff;\n}\n\n.agent-voucher-flight-head,\n.agent-voucher-flight-foot {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 0.35rem 0.75rem;\n}\n\n.agent-voucher-flight-leg {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--brand, #c6272a);\n}\n\n.agent-voucher-flight-meta,\n.agent-voucher-hotel-stay,\n.agent-voucher-flight-foot,\n.agent-voucher-note,\n.agent-voucher-empty,\n.agent-voucher-footer {\n  font-size: 0.82rem;\n  color: #4b5563;\n}\n\n.agent-voucher-route {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 0.6rem;\n  margin: 0.75rem 0 0.7rem;\n}\n\n.agent-voucher-airport-kicker {\n  font-size: 0.65rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #9ca3af;\n}\n\n.agent-voucher-airport-name {\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: #111827;\n  line-height: 1.3;\n}\n\n.agent-voucher-airport--end {\n  text-align: right;\n}\n\n.agent-voucher-route-line {\n  width: 3.25rem;\n  height: 2px;\n  background: #e5e7eb;\n  position: relative;\n}\n\n.agent-voucher-route-line::after {\n  content: \"\";\n  position: absolute;\n  right: -1px;\n  top: 50%;\n  width: 7px;\n  height: 7px;\n  border-top: 2px solid #c6272a;\n  border-right: 2px solid #c6272a;\n  transform: translateY(-50%) rotate(45deg);\n}\n\n.agent-voucher-flight-foot {\n  border-top: 1px dashed #ececec;\n  padding-top: 0.55rem;\n}\n\n.agent-voucher-hotels {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.85rem;\n}\n\n.agent-voucher-hotel-city {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--brand, #c6272a);\n}\n\n.agent-voucher-hotel-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0.2rem 0 0.25rem;\n}\n\n.agent-voucher-note {\n  margin: 0.75rem 0 0;\n}\n\n.agent-voucher-empty {\n  margin: 0 0 0.75rem;\n}\n\n.agent-voucher-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 0.75rem;\n}\n\n.agent-voucher-table th,\n.agent-voucher-table td {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 0.55rem 0.4rem;\n  text-align: left;\n  font-size: 0.88rem;\n  vertical-align: top;\n}\n\n.agent-voucher-table th {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #6b7280;\n  background: #fafafa;\n}\n\n.agent-voucher-table td {\n  color: #111827;\n  font-weight: 500;\n}\n\n.agent-voucher-footer {\n  margin-top: 0.5rem;\n  padding: 1rem 1.5rem 1.25rem;\n  border-top: 1px solid #eee;\n}\n\n.agent-voucher-footer p {\n  margin: 0;\n}\n\n.agent-voucher-footer p + p {\n  margin-top: 0.25rem;\n}\n\n[data-theme=\"dark\"] .agent-voucher-sheet,\n[data-theme=\"dark\"] .agent-voucher-letterhead,\n[data-theme=\"dark\"] .agent-voucher-flight,\n[data-theme=\"dark\"] .agent-voucher-hotel,\n[data-theme=\"dark\"] .agent-voucher-table th {\n  background: #fff;\n}\n\n[data-theme=\"dark\"] .agent-voucher-brand-name,\n[data-theme=\"dark\"] .agent-voucher-docmark-ref,\n[data-theme=\"dark\"] .agent-voucher-value,\n[data-theme=\"dark\"] .agent-voucher-airport-name,\n[data-theme=\"dark\"] .agent-voucher-hotel-name,\n[data-theme=\"dark\"] .agent-voucher-table td {\n  color: #111827;\n}\n\n@media (max-width: 767.98px) {\n  .agent-voucher-meta,\n  .agent-voucher-meta--3,\n  .agent-voucher-flights--split,\n  .agent-voucher-hotels {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .agent-voucher-docmark {\n    text-align: left;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .agent-voucher-meta,\n  .agent-voucher-meta--3,\n  .agent-voucher-flights--split,\n  .agent-voucher-hotels,\n  .agent-voucher-route {\n    grid-template-columns: 1fr;\n  }\n\n  .agent-voucher-airport--end {\n    text-align: left;\n  }\n\n  .agent-voucher-route-line {\n    width: 100%;\n    margin: 0.15rem 0;\n  }\n}\n\n@media print {\n  @page {\n    size: A4;\n    margin: 10mm;\n  }\n\n  html,\n  body.agent-voucher-open,\n  body.agent-voucher-open .app-shell,\n  body.agent-voucher-open .dashboard-main,\n  body.agent-voucher-open .dashboard-main-body,\n  body.agent-voucher-open .agent-voucher-page {\n    background: #fff !important;\n    color: #111827 !important;\n    width: 100% !important;\n    max-width: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    overflow: visible !important;\n    box-shadow: none !important;\n  }\n\n  body.agent-voucher-open .sidebar,\n  body.agent-voucher-open .navbar-header,\n  body.agent-voucher-open .d-footer,\n  body.agent-voucher-open .agent-voucher-toolbar,\n  body.agent-voucher-open .sidebar-close-btn {\n    display: none !important;\n  }\n\n  body.agent-voucher-open .dashboard-main,\n  body.agent-voucher-open.app-shell.sidebar-collapsed .dashboard-main,\n  .app-shell.sidebar-collapsed .dashboard-main {\n    margin-inline-start: 0 !important;\n  }\n\n  .agent-voucher-sheet {\n    border: 0 !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    overflow: visible !important;\n  }\n\n  .agent-voucher-section,\n  .agent-voucher-flight,\n  .agent-voucher-hotel,\n  .agent-voucher-table,\n  .agent-voucher-letterhead {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n\n  .agent-voucher-flights--split,\n  .agent-voucher-hotels,\n  .agent-voucher-meta,\n  .agent-voucher-meta--3 {\n    grid-template-columns: 1fr 1fr !important;\n  }\n\n  * {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n}\n\n.agent-otp-row {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.agent-otp-input {\n  width: 52px;\n  height: 56px;\n  flex: 0 0 52px;\n  text-align: center;\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 56px;\n  padding: 0;\n  border: 1px solid #dbe0e6;\n  border-radius: 12px;\n  background: #f7f8fa;\n  color: #111827;\n  caret-color: #c6272a;\n  box-shadow: none;\n}\n\n.agent-otp-input:focus {\n  border-color: #c6272a;\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(198, 39, 42, 0.16);\n  outline: none;\n}\n\n.agent-otp-input.is-filled {\n  border-color: #c6272a;\n  background: #fff;\n}\n\n.agent-otp-input:-webkit-autofill,\n.agent-otp-input:-webkit-autofill:hover,\n.agent-otp-input:-webkit-autofill:focus {\n  -webkit-text-fill-color: #111827;\n  -webkit-box-shadow: 0 0 0 1000px #fff inset;\n  border-color: #c6272a;\n  transition: background-color 9999s ease-out;\n}\n\n.agent-onboarding-page .form-wizard-list__item.activated .count {\n  background-color: var(--success-main, #45b369);\n  border-color: var(--success-main, #45b369);\n  color: #fff;\n}\n\n.agent-onboarding-page .form-wizard-list__item.activated .text {\n  color: var(--success-main, #45b369);\n}\n\n.agent-onboarding-page .form-wizard-list__item.activated .form-wizard-list__line::before {\n  background-color: var(--success-main, #45b369);\n}\n\n.agent-onboarding-art {\n  padding: 28px 12px 8px;\n}\n\n.agent-onboarding-art__svg {\n  width: min(560px, 100%);\n  height: auto;\n  display: block;\n  margin: 0 auto 12px;\n}\n\n.agent-empty-art {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n\n.agent-empty-art__svg {\n  width: min(280px, 100%);\n  height: auto;\n  display: block;\n  margin: 0 auto 1rem;\n}\n\n.password-strength {\n  margin-top: 10px;\n}\n\n.password-strength__meter {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.password-strength__bar {\n  height: 6px;\n  border-radius: 999px;\n  background: #e5e7eb;\n}\n\n.password-strength__bar.is-filled {\n  background: #c6272a;\n}\n\n.password-strength.is-fair .password-strength__bar.is-filled {\n  background: #e6a23c;\n}\n\n.password-strength.is-good .password-strength__bar.is-filled {\n  background: #3b82f6;\n}\n\n.password-strength.is-strong .password-strength__bar.is-filled {\n  background: #45b369;\n}\n\n.password-strength__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  margin-bottom: 8px;\n}\n\n.password-strength.is-weak .password-strength__label {\n  color: #c6272a;\n}\n\n.password-strength.is-fair .password-strength__label {\n  color: #b45309;\n}\n\n.password-strength.is-good .password-strength__label {\n  color: #1d4ed8;\n}\n\n.password-strength.is-strong .password-strength__label {\n  color: #15803d;\n}\n\n.password-strength__checks {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 4px;\n}\n\n.password-strength__checks li {\n  position: relative;\n  padding-left: 18px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.password-strength__checks li::before {\n  content: \"○\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  color: #9ca3af;\n}\n\n.password-strength__checks li.is-passed {\n  color: #15803d;\n}\n\n.password-strength__checks li.is-passed::before {\n  content: \"✓\";\n  color: #45b369;\n}\n\n.agent-onboarding-footer {\n  background: #fff;\n  border-top: 1px solid #ececec;\n}\n\n.agent-onboarding-shell {\n  width: 100%;\n  background: #fff;\n  border: 1px solid #ececec;\n  border-radius: 16px;\n  padding: 24px 24px 8px;\n}\n\n.agent-onboarding-shell > .card {\n  border-color: #f0f0f0;\n  box-shadow: none;\n}\n\n.agent-onboarding-page .alert.radius-4 {\n  border-radius: 4px;\n}\n\n@media (max-width: 767.98px) {\n  .agent-onboarding-page .form-wizard-list__item .text {\n    white-space: nowrap;\n  }\n\n  .agent-onboarding-shell {\n    padding: 16px 16px 4px;\n  }\n\n  .agent-onboarding-page .card-body {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .agent-otp-input {\n    width: 42px;\n    height: 48px;\n    flex-basis: 42px;\n    font-size: 18px;\n    line-height: 48px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
